import React from "react";


export const Notifi = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={props.width}
      height={props.height}
    >
      <g
        id="vuesax_linear_notification"
        data-name="vuesax/linear/notification"
        transform="translate(-171 -188)"
      >
        <g id="notification">
          <path
            id="Vector"
            d="M8.046,0a6,6,0,0,0-6,6V8.89a4.778,4.778,0,0,1-.57,2.06L.326,12.86a1.919,1.919,0,0,0,1.08,2.93,20.921,20.921,0,0,0,13.27,0,2,2,0,0,0,1.08-2.93l-1.15-1.91a4.91,4.91,0,0,1-.56-2.06V6A6.018,6.018,0,0,0,8.046,0Z"
            transform="translate(174.974 190.91)"
            fill={props.theme === "light" ? "#5c44af" : "#ffffff"}
            stroke={props.theme === "light" ? "#5c44af" : "#ffffff"}
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M3.7,1.26a6.054,6.054,0,0,0-.96-.2A6.754,6.754,0,0,0,0,1.26a1.988,1.988,0,0,1,3.7,0Z"
            transform="translate(181.17 189.94)"
            fill={props.theme === "light" ? "#5c44af" : "#ffffff"}
            stroke={props.theme === "light" ? "#5c44af" : "#ffffff"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M6,0A3.009,3.009,0,0,1,3,3,3.011,3.011,0,0,1,.88,2.12,3.011,3.011,0,0,1,0,0"
            transform="translate(180.02 207.06)"
            fill={props.theme === "light" ? "#5c44af" : "#ffffff"}
            stroke={props.theme === "light" ? "#5c44af" : "#ffffff"}
            strokeWidth="1.5"
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M0,0H24V24H0Z"
            transform="translate(171 188)"
            fill={props.theme === "light" ? "#5c44af" : "#ffffff"}
            opacity="0"
          />
        </g>
      </g>
    </svg>
  );
};

export const Reaction = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        fill={props.color ? props.color : "#363853"}
        d="M12,0A12.013,12.013,0,0,0,0,12c.6,15.9,23.4,15.893,24,0A12.013,12.013,0,0,0,12,0ZM6.5,7A1.581,1.581,0,0,1,8,8.65c.41-3.617,6.167-.78.465,3.494a.743.743,0,0,1-.93,0C6.692,11.468,5,9.948,5,8.65A1.581,1.581,0,0,1,6.5,7Zm11.342,8.542A6.827,6.827,0,0,1,12,19a6.836,6.836,0,0,1-5.848-3.458A1,1,0,0,1,7.2,14.024,15.4,15.4,0,0,0,12,15a15.4,15.4,0,0,0,4.792-.976A1,1,0,0,1,17.842,15.542Zm-1.377-3.4a.743.743,0,0,1-.93,0c-5.7-4.279.059-7.109.465-3.494C16.41,5.033,22.167,7.87,16.465,12.144Z"
      />
    </svg>
  );
};
export const Preview = (props) => {
  return (
    <svg
      width="30"
      height="24"
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.25 11.567C18.5833 11.7594 18.5833 12.2406 18.25 12.433L10.75 16.7631C10.4167 16.9556 10 16.715 10 16.3301L10 7.66987C10 7.28497 10.4167 7.04441 10.75 7.23686L18.25 11.567Z"
        stroke="#3B3B3B"
        strokeOpacity="0.7"
      />
      <rect
        x="0.5"
        y="0.5"
        width="25"
        height="23"
        rx="5.5"
        stroke="#3B3B3B"
        strokeOpacity="0.7"
      />
      <path
        d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H24C27.0376 0.5 29.5 2.96243 29.5 6V18C29.5 21.0376 27.0376 23.5 24 23.5H6C2.96243 23.5 0.5 21.0376 0.5 18V6Z"
        stroke="#3B3B3B"
        strokeOpacity="0.7"
      />
    </svg>
  );
};

export const Follow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
    >
      <g
        id="vuesax_bold_profile-2user"
        data-name="vuesax/bold/profile-2user"
        transform="translate(-172 -252)"
      >
        <g id="profile-2user">
          <path
            id="Vector"
            d="M4.75,0a4.746,4.746,0,0,0-.12,9.49.807.807,0,0,1,.22,0h.07A4.746,4.746,0,0,0,4.75,0Z"
            transform="translate(176.25 254)"
            fill={props.color ? props.color : "#363853"}
          />
          <path
            id="Vector-2"
            data-name="Vector"
            d="M12.12,1.395a9.929,9.929,0,0,0-10.15,0A3.947,3.947,0,0,0,0,4.625a3.914,3.914,0,0,0,1.96,3.21,9.239,9.239,0,0,0,5.08,1.41,9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23A3.937,3.937,0,0,0,12.12,1.395Z"
            transform="translate(173.96 264.755)"
            fill={props.color ? props.color : "#363853"}
          />
          <path
            id="Vector-3"
            data-name="Vector"
            d="M5.88,3.283a3.579,3.579,0,0,1-3.13,3.87H2.7a.468.468,0,0,0-.17.02A3.588,3.588,0,0,1,0,6.343a4.576,4.576,0,0,0,1.5-3.8A4.641,4.641,0,0,0,.73.363a3.59,3.59,0,0,1,5.15,2.92Z"
            transform="translate(186.11 256.057)"
            fill={props.color ? props.color : "#363853"}
          />
          <path
            id="Vector-4"
            data-name="Vector"
            d="M8,4.09A3.046,3.046,0,0,1,6.26,6.47a7.058,7.058,0,0,1-3.51.78A3.569,3.569,0,0,0,3.97,4.93,3.94,3.94,0,0,0,2.3,1.55,8.255,8.255,0,0,0,0,.29,7.815,7.815,0,0,1,6.7,1.46,3.038,3.038,0,0,1,8,4.09Z"
            transform="translate(185.99 264.5)"
            fill={props.color ? props.color : "#363853"}
          />
          <path
            id="Vector-5"
            data-name="Vector"
            d="M0,0H24V24H0Z"
            transform="translate(196 276) rotate(180)"
            fill="none"
            opacity="0"
          />
        </g>
      </g>
    </svg>
  );
};

export const Event = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        fill={props.color ? props.color : "#363853"}
        d="m14.823 11.708a.325.325 0 0 1 .169.292.314.314 0 0 1 -.12.266l-5.372 2.688a.337.337 0 0 1 -.5-.293v-5.322a.327.327 0 0 1 .168-.292.314.314 0 0 1 .157-.042.462.462 0 0 1 .228.068zm9.177-6.708v14a5.006 5.006 0 0 1 -5 5h-14a5.006 5.006 0 0 1 -5-5v-14a5.006 5.006 0 0 1 5-5h14a5.006 5.006 0 0 1 5 5zm-7.008 7a2.332 2.332 0 0 0 -1.226-2.055l-5.278-2.635a2.337 2.337 0 0 0 -3.5 2.029v5.322a2.313 2.313 0 0 0 1.164 2.021 2.368 2.368 0 0 0 1.186.323 2.2 2.2 0 0 0 1.1-.289l5.376-2.687a2.313 2.313 0 0 0 1.178-2.029z"
      />
    </svg>
  );
};

export const Monetization = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        fill={props.color ? props.color : "#363853"}
        d="M2,15h9v9H7a5,5,0,0,1-5-5Zm22-4a2,2,0,0,1-2,2H13V8.957c-.336.026-.671.043-1,.043s-.664-.017-1-.043V13H2a2,2,0,0,1-2-2A4,4,0,0,1,4,7H5.738A5.137,5.137,0,0,1,4,3,1,1,0,0,1,6,3c0,2.622,2.371,3.53,4.174,3.841A9.332,9.332,0,0,1,9,3a3,3,0,0,1,6,0,9.332,9.332,0,0,1-1.174,3.841C15.629,6.53,18,5.622,18,3a1,1,0,0,1,2,0,5.137,5.137,0,0,1-1.738,4H20A4,4,0,0,1,24,11ZM11,3a7.71,7.71,0,0,0,1,3.013A7.71,7.71,0,0,0,13,3a1,1,0,0,0-2,0Zm2,21h4a5,5,0,0,0,5-5V15H13Z"
      />
    </svg>
  );
};

export const Comment = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 24 24"
    >
      <path
        fill={props.color ? props.color : props.color}
        d="M19.675,2.758A11.936,11.936,0,0,0,10.474.1,12,12,0,0,0,12.018,24H19a5.006,5.006,0,0,0,5-5V11.309l0-.063A12.044,12.044,0,0,0,19.675,2.758ZM8,7h4a1,1,0,0,1,0,2H8A1,1,0,0,1,8,7Zm8,10H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Zm0-4H8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
      />
    </svg>
  );
};

export const ProfileAvatar = (props) => {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26 26"
      width={props.width}
      height={props.height}
    >
      <path
        fill={props.color ? props.color : "#363853"}
        d="M13,0A13,13,0,1,0,26,13,13.01442,13.01442,0,0,0,13,0Zm0,25A12,12,0,1,1,25,13,12.01343,12.01343,0,0,1,13,25Z"
      />
      <path
        fill={props.color ? props.color : "#363853"}
        d="M20.959,17.88574c-1.44531-.68359-3.25976-1.36719-3.94336-1.625l-.1455-.05469c-.39453-.14843-.45508-.77441-.457-.77441V13.82617a3.87785,3.87785,0,0,0,.40332-.88867A.917.917,0,0,0,16.999,12.895a1.359,1.359,0,0,0,.72559-.68408c.60059-1.25537.71191-2.14893.33887-2.73291a1.13228,1.13228,0,0,0-.42481-.395,5.43925,5.43925,0,0,0-.82031-3.3628c-1.21289-2.10156-4.02881-2.54589-4.14795-2.564a.49623.49623,0,0,0-.53027.28955.489.489,0,0,0-.03614.11768,3.45651,3.45651,0,0,0-1.10009-.23.46546.46546,0,0,0-.32178.10009.52773.52773,0,0,0-.18652-.02539.49988.49988,0,0,0-.46875.437,9.56277,9.56277,0,0,1-.75049,2.70313,5.08346,5.08346,0,0,0-.42481,2.66455,1.27613,1.27613,0,0,0-.31885.519,4.1,4.1,0,0,0,.48291,2.61866.89279.89279,0,0,0,.76905.57226c.02929-.001.05664.00049.08349-.00244a4.38235,4.38235,0,0,0,.25293.63721l.002,1.83984a.89992.89992,0,0,1-.58155.92578,18.734,18.734,0,0,0-4.66357,1.39063.50639.50639,0,0,0-.271.31836.51411.51411,0,0,0,.05957.418,9.76576,9.76576,0,0,0,6.15577,4.32519,9.87561,9.87561,0,0,0,2.16162.24023A9.85212,9.85212,0,0,0,21.124,18.665a.50793.50793,0,0,0,.11817-.38477A.50153.50153,0,0,0,20.959,17.88574Zm-3.26171,2.751A8.82941,8.82941,0,0,1,5.83643,18.39258,18.18076,18.18076,0,0,1,9.76221,17.2959a1.892,1.892,0,0,0,1.35888-1.94043V13.438a.49693.49693,0,0,0-.05761-.23291,3.40927,3.40927,0,0,1-.36377-1.147.50105.50105,0,0,0-.85254-.28321,2.998,2.998,0,0,1-.36524-1.728.23511.23511,0,0,1,.12745-.15918.50052.50052,0,0,0,.27148-.5337,4.09454,4.09454,0,0,1,.3081-2.396,10.594,10.594,0,0,0,.55469-1.57178,1.0152,1.0152,0,0,0,.27051.17139.90983.90983,0,0,0,.84082-.0708.72871.72871,0,0,0,.36621-.57715.75038.75038,0,0,0-.00488-.16846,2.52032,2.52032,0,0,1,.28125.21826.49991.49991,0,0,0,.79834-.18554,1.31756,1.31756,0,0,0,.09277-.40381,4.61909,4.61909,0,0,1,2.57422,1.86767,4.47017,4.47017,0,0,1,.63574,3.12012.49976.49976,0,0,0,.49317.581h.00683a.19032.19032,0,0,1,.12207.07764c.043.06641.22364.46436-.39746,1.76123-.03515.06934-.1084.15674-.15234.15772a.50023.50023,0,0,0-.72363.35449,2.90386,2.90386,0,0,1-.44922,1.11035.496.496,0,0,0-.085.27881l.001,1.78174A1.91491,1.91491,0,0,0,16.5166,17.1416l.14649.05567c.58789.2207,2.02832.76367,3.32129,1.34179A8.75967,8.75967,0,0,1,17.69727,20.63672Z"
      />
    </svg>
  );
};

//===================================DIRECTOR'S ICONS=================================
export const DirectorCam = (props) => {
  return (
    <svg
      width={props.width?props.width:"14"}
      height={props.height?props.height:"10"}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.2073 1.2H7.55069C7.93628 1.2 8.25678 1.52049 8.25678 1.90609V8.0939C8.25678 8.47947 7.93631 8.79999 7.55062 8.79999H2.78004C2.39452 8.79999 2.07402 8.47956 2.07402 8.0939V4.33335C2.07402 2.61275 3.48675 1.2 5.2073 1.2ZM7.55069 0H5.2073C2.82399 0 0.874023 1.95003 0.874023 4.33335V8.0939C0.874023 9.14227 1.73175 9.99999 2.78004 9.99999H7.55062C8.59899 9.99999 9.45678 9.14227 9.45678 8.0939V7.3907L11.2488 8.67226L11.2718 8.68871L11.2962 8.70292C12.1079 9.17485 13.1257 8.58926 13.1257 7.65036V2.34947C13.1257 1.39273 12.073 0.8098 11.2621 1.31753L11.2373 1.33306L11.2141 1.35092L9.45678 2.70596V1.90609C9.45678 0.857716 8.59899 0 7.55069 0ZM9.45678 4.22127V5.91541L11.9084 7.66872C11.9101 7.66848 11.9132 7.66772 11.9169 7.66556C11.9218 7.66274 11.9241 7.65975 11.9246 7.65886L11.925 7.6579C11.9251 7.65756 11.9257 7.65532 11.9257 7.65036V2.34947M9.45678 4.22127L11.9081 2.33107C11.9099 2.33131 11.9129 2.33206 11.9167 2.33413C11.9219 2.337 11.9242 2.34008 11.9247 2.34086"
        fill={props.color}
      />
    </svg>
  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M10.4783 6.88183L7.08964 10.2704C7.0064 10.3537 6.89927 10.4089 6.78317 10.4284L5.47295 10.6485C5.40562 10.6598 5.34702 10.6018 5.35771 10.5343L5.56693 9.21409C5.58563 9.09605 5.64123 8.98696 5.72574 8.90245L9.1123 5.51588C9.33334 5.29484 9.69173 5.29484 9.91277 5.51588L10.4783 6.08137C10.6993 6.30241 10.6993 6.66079 10.4783 6.88183Z" stroke={ props.color } strokeMiterlimit="10"
      />
      <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke={props.color} />
    </svg>

  );
};

export const CloseTempIcon = (props) => {
  return (
    <svg width="103" height="20" viewBox="0 0 103 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M12.8986 10.707L16.2927 14.1011L16.9998 13.394L13.6057 9.99988L16.9998 6.60579L16.2927 5.89868L12.8986 9.29278L9.50447 5.89868L8.79736 6.60579L12.1915 9.99988L8.79736 13.394L9.50447 14.1011L12.8986 10.707Z" fill={props.color} />
      <path d="M27.03 7.55C26.65 7.55 26.3067 7.61667 26 7.75C25.6933 7.87667 25.4333 8.06667 25.22 8.32C25.0067 8.56667 24.8433 8.87 24.73 9.23C24.6167 9.58333 24.56 9.98333 24.56 10.43C24.56 11.0167 24.65 11.5267 24.83 11.96C25.0167 12.3933 25.29 12.7267 25.65 12.96C26.0167 13.1933 26.4733 13.31 27.02 13.31C27.3333 13.31 27.63 13.2833 27.91 13.23C28.19 13.1767 28.4633 13.11 28.73 13.03V13.81C28.4633 13.91 28.1867 13.9833 27.9 14.03C27.62 14.0767 27.2833 14.1 26.89 14.1C26.1633 14.1 25.5567 13.95 25.07 13.65C24.5833 13.35 24.2167 12.9233 23.97 12.37C23.73 11.8167 23.61 11.1667 23.61 10.42C23.61 9.88 23.6833 9.38667 23.83 8.94C23.9833 8.49333 24.2033 8.10667 24.49 7.78C24.7833 7.45333 25.1433 7.20333 25.57 7.03C25.9967 6.85 26.4867 6.76 27.04 6.76C27.4067 6.76 27.76 6.79667 28.1 6.87C28.44 6.94333 28.7433 7.04667 29.01 7.18L28.65 7.94C28.43 7.84 28.1833 7.75 27.91 7.67C27.6433 7.59 27.35 7.55 27.03 7.55ZM31.0484 14H30.1684V6.4H31.0484V14ZM37.4065 11.31C37.4065 11.7567 37.3465 12.1533 37.2265 12.5C37.1132 12.84 36.9465 13.13 36.7265 13.37C36.5132 13.61 36.2498 13.7933 35.9365 13.92C35.6298 14.04 35.2865 14.1 34.9065 14.1C34.5532 14.1 34.2265 14.04 33.9265 13.92C33.6265 13.7933 33.3665 13.61 33.1465 13.37C32.9265 13.13 32.7532 12.84 32.6265 12.5C32.5065 12.1533 32.4465 11.7567 32.4465 11.31C32.4465 10.7167 32.5465 10.2167 32.7465 9.81C32.9465 9.39667 33.2332 9.08333 33.6065 8.87C33.9798 8.65 34.4232 8.54 34.9365 8.54C35.4232 8.54 35.8498 8.65 36.2165 8.87C36.5898 9.08333 36.8798 9.39667 37.0865 9.81C37.2998 10.2167 37.4065 10.7167 37.4065 11.31ZM33.3565 11.31C33.3565 11.73 33.4098 12.0967 33.5165 12.41C33.6298 12.7167 33.8032 12.9533 34.0365 13.12C34.2698 13.2867 34.5665 13.37 34.9265 13.37C35.2865 13.37 35.5832 13.2867 35.8165 13.12C36.0498 12.9533 36.2198 12.7167 36.3265 12.41C36.4398 12.0967 36.4965 11.73 36.4965 11.31C36.4965 10.8833 36.4398 10.52 36.3265 10.22C36.2132 9.92 36.0398 9.69 35.8065 9.53C35.5798 9.36333 35.2832 9.28 34.9165 9.28C34.3698 9.28 33.9732 9.46 33.7265 9.82C33.4798 10.18 33.3565 10.6767 33.3565 11.31ZM42.2912 12.52C42.2912 12.8667 42.2045 13.1567 42.0312 13.39C41.8578 13.6233 41.6112 13.8 41.2912 13.92C40.9712 14.04 40.5912 14.1 40.1512 14.1C39.7778 14.1 39.4545 14.07 39.1812 14.01C38.9145 13.95 38.6778 13.8667 38.4712 13.76V12.96C38.6845 13.0667 38.9412 13.1667 39.2412 13.26C39.5478 13.3467 39.8578 13.39 40.1712 13.39C40.6178 13.39 40.9412 13.32 41.1412 13.18C41.3412 13.0333 41.4412 12.84 41.4412 12.6C41.4412 12.4667 41.4045 12.3467 41.3312 12.24C41.2578 12.1333 41.1245 12.0267 40.9312 11.92C40.7445 11.8133 40.4745 11.6933 40.1212 11.56C39.7745 11.4267 39.4778 11.2933 39.2312 11.16C38.9845 11.0267 38.7945 10.8667 38.6612 10.68C38.5278 10.4933 38.4612 10.2533 38.4612 9.96C38.4612 9.50667 38.6445 9.15667 39.0112 8.91C39.3845 8.66333 39.8712 8.54 40.4712 8.54C40.7978 8.54 41.1012 8.57333 41.3812 8.64C41.6678 8.7 41.9345 8.78667 42.1812 8.9L41.8812 9.6C41.7345 9.53333 41.5778 9.47667 41.4112 9.43C41.2512 9.37667 41.0878 9.33667 40.9212 9.31C40.7545 9.27667 40.5845 9.26 40.4112 9.26C40.0512 9.26 39.7745 9.32 39.5812 9.44C39.3945 9.55333 39.3012 9.71 39.3012 9.91C39.3012 10.0567 39.3445 10.1833 39.4312 10.29C39.5178 10.39 39.6612 10.49 39.8612 10.59C40.0678 10.6833 40.3412 10.7967 40.6812 10.93C41.0212 11.0567 41.3112 11.1867 41.5512 11.32C41.7912 11.4533 41.9745 11.6167 42.1012 11.81C42.2278 11.9967 42.2912 12.2333 42.2912 12.52ZM45.6563 8.54C46.1163 8.54 46.5097 8.64 46.8363 8.84C47.1697 9.04 47.423 9.32333 47.5963 9.69C47.7763 10.05 47.8663 10.4733 47.8663 10.96V11.49H44.1963C44.2097 12.0967 44.363 12.56 44.6563 12.88C44.9563 13.1933 45.373 13.35 45.9063 13.35C46.2463 13.35 46.5463 13.32 46.8063 13.26C47.073 13.1933 47.3463 13.1 47.6263 12.98V13.75C47.353 13.87 47.083 13.9567 46.8163 14.01C46.5497 14.07 46.233 14.1 45.8663 14.1C45.3597 14.1 44.9097 13.9967 44.5163 13.79C44.1297 13.5833 43.8263 13.2767 43.6063 12.87C43.393 12.4567 43.2863 11.9533 43.2863 11.36C43.2863 10.7733 43.383 10.27 43.5763 9.85C43.7763 9.43 44.053 9.10667 44.4063 8.88C44.7663 8.65333 45.183 8.54 45.6563 8.54ZM45.6463 9.26C45.2263 9.26 44.893 9.39667 44.6463 9.67C44.4063 9.93667 44.263 10.31 44.2163 10.79H46.9463C46.9463 10.4833 46.8997 10.2167 46.8063 9.99C46.713 9.76333 46.5697 9.58667 46.3763 9.46C46.1897 9.32667 45.9463 9.26 45.6463 9.26ZM54.2085 14H53.3085V7.65H51.0785V6.86H56.4285V7.65H54.2085V14ZM58.752 8.54C59.212 8.54 59.6054 8.64 59.932 8.84C60.2654 9.04 60.5187 9.32333 60.692 9.69C60.872 10.05 60.962 10.4733 60.962 10.96V11.49H57.292C57.3054 12.0967 57.4587 12.56 57.752 12.88C58.052 13.1933 58.4687 13.35 59.002 13.35C59.342 13.35 59.642 13.32 59.902 13.26C60.1687 13.1933 60.442 13.1 60.722 12.98V13.75C60.4487 13.87 60.1787 13.9567 59.912 14.01C59.6454 14.07 59.3287 14.1 58.962 14.1C58.4554 14.1 58.0054 13.9967 57.612 13.79C57.2254 13.5833 56.922 13.2767 56.702 12.87C56.4887 12.4567 56.382 11.9533 56.382 11.36C56.382 10.7733 56.4787 10.27 56.672 9.85C56.872 9.43 57.1487 9.10667 57.502 8.88C57.862 8.65333 58.2787 8.54 58.752 8.54ZM58.742 9.26C58.322 9.26 57.9887 9.39667 57.742 9.67C57.502 9.93667 57.3587 10.31 57.312 10.79H60.042C60.042 10.4833 59.9954 10.2167 59.902 9.99C59.8087 9.76333 59.6654 9.58667 59.472 9.46C59.2854 9.32667 59.042 9.26 58.742 9.26ZM68.2066 8.54C68.8132 8.54 69.2666 8.69667 69.5666 9.01C69.8666 9.31667 70.0166 9.81667 70.0166 10.51V14H69.1466V10.55C69.1466 10.13 69.0566 9.81333 68.8766 9.6C68.7032 9.38667 68.4299 9.28 68.0566 9.28C67.5366 9.28 67.1632 9.43 66.9366 9.73C66.7166 10.03 66.6066 10.4667 66.6066 11.04V14H65.7366V10.55C65.7366 10.27 65.6966 10.0367 65.6166 9.85C65.5366 9.65667 65.4166 9.51333 65.2566 9.42C65.0966 9.32667 64.8899 9.28 64.6366 9.28C64.2766 9.28 63.9932 9.35667 63.7866 9.51C63.5799 9.65667 63.4299 9.87333 63.3366 10.16C63.2499 10.4467 63.2066 10.8 63.2066 11.22V14H62.3266V8.64H63.0366L63.1666 9.37H63.2166C63.3299 9.18333 63.4666 9.03 63.6266 8.91C63.7932 8.78333 63.9766 8.69 64.1766 8.63C64.3766 8.57 64.5832 8.54 64.7966 8.54C65.2099 8.54 65.5532 8.61333 65.8266 8.76C66.1066 8.90667 66.3099 9.13333 66.4366 9.44H66.4866C66.6666 9.13333 66.9099 8.90667 67.2166 8.76C67.5299 8.61333 67.8599 8.54 68.2066 8.54ZM74.2223 8.54C74.8823 8.54 75.4123 8.77 75.8123 9.23C76.2189 9.69 76.4223 10.3833 76.4223 11.31C76.4223 11.9167 76.3289 12.43 76.1423 12.85C75.9623 13.2633 75.7056 13.5767 75.3723 13.79C75.0456 13.9967 74.6589 14.1 74.2123 14.1C73.9389 14.1 73.6956 14.0633 73.4823 13.99C73.2689 13.9167 73.0856 13.8233 72.9323 13.71C72.7856 13.59 72.6589 13.46 72.5523 13.32H72.4923C72.5056 13.4333 72.5189 13.5767 72.5323 13.75C72.5456 13.9233 72.5523 14.0733 72.5523 14.2V16.4H71.6723V8.64H72.3923L72.5123 9.37H72.5523C72.6589 9.21667 72.7856 9.07667 72.9323 8.95C73.0856 8.82333 73.2656 8.72333 73.4723 8.65C73.6856 8.57667 73.9356 8.54 74.2223 8.54ZM74.0623 9.28C73.7023 9.28 73.4123 9.35 73.1923 9.49C72.9723 9.62333 72.8123 9.82667 72.7123 10.1C72.6123 10.3733 72.5589 10.72 72.5523 11.14V11.31C72.5523 11.75 72.5989 12.1233 72.6923 12.43C72.7856 12.7367 72.9423 12.97 73.1623 13.13C73.3889 13.29 73.6956 13.37 74.0823 13.37C74.4089 13.37 74.6756 13.28 74.8823 13.1C75.0956 12.92 75.2523 12.6767 75.3523 12.37C75.4589 12.0567 75.5123 11.7 75.5123 11.3C75.5123 10.6867 75.3923 10.1967 75.1523 9.83C74.9189 9.46333 74.5556 9.28 74.0623 9.28ZM78.7046 14H77.8246V6.4H78.7046V14ZM82.4327 8.55C83.0861 8.55 83.5694 8.69333 83.8827 8.98C84.1961 9.26667 84.3527 9.72333 84.3527 10.35V14H83.7127L83.5427 13.24H83.5027C83.3494 13.4333 83.1894 13.5967 83.0227 13.73C82.8627 13.8567 82.6761 13.95 82.4627 14.01C82.2561 14.07 82.0027 14.1 81.7027 14.1C81.3827 14.1 81.0927 14.0433 80.8327 13.93C80.5794 13.8167 80.3794 13.6433 80.2327 13.41C80.0861 13.17 80.0127 12.87 80.0127 12.51C80.0127 11.9767 80.2227 11.5667 80.6427 11.28C81.0627 10.9867 81.7094 10.8267 82.5827 10.8L83.4927 10.77V10.45C83.4927 10.0033 83.3961 9.69333 83.2027 9.52C83.0094 9.34667 82.7361 9.26 82.3827 9.26C82.1027 9.26 81.8361 9.30333 81.5827 9.39C81.3294 9.47 81.0927 9.56333 80.8727 9.67L80.6027 9.01C80.8361 8.88333 81.1127 8.77667 81.4327 8.69C81.7527 8.59667 82.0861 8.55 82.4327 8.55ZM82.6927 11.41C82.0261 11.4367 81.5627 11.5433 81.3027 11.73C81.0494 11.9167 80.9227 12.18 80.9227 12.52C80.9227 12.82 81.0127 13.04 81.1927 13.18C81.3794 13.32 81.6161 13.39 81.9027 13.39C82.3561 13.39 82.7327 13.2667 83.0327 13.02C83.3327 12.7667 83.4827 12.38 83.4827 11.86V11.38L82.6927 11.41ZM87.7982 13.38C87.9315 13.38 88.0682 13.37 88.2082 13.35C88.3482 13.3233 88.4615 13.2967 88.5482 13.27V13.94C88.4549 13.9867 88.3215 14.0233 88.1482 14.05C87.9749 14.0833 87.8082 14.1 87.6482 14.1C87.3682 14.1 87.1082 14.0533 86.8682 13.96C86.6349 13.86 86.4449 13.69 86.2982 13.45C86.1515 13.21 86.0782 12.8733 86.0782 12.44V9.32H85.3182V8.9L86.0882 8.55L86.4382 7.41H86.9582V8.64H88.5082V9.32H86.9582V12.42C86.9582 12.7467 87.0349 12.99 87.1882 13.15C87.3482 13.3033 87.5515 13.38 87.7982 13.38ZM91.6915 8.54C92.1515 8.54 92.5448 8.64 92.8715 8.84C93.2048 9.04 93.4582 9.32333 93.6315 9.69C93.8115 10.05 93.9015 10.4733 93.9015 10.96V11.49H90.2315C90.2448 12.0967 90.3982 12.56 90.6915 12.88C90.9915 13.1933 91.4082 13.35 91.9415 13.35C92.2815 13.35 92.5815 13.32 92.8415 13.26C93.1082 13.1933 93.3815 13.1 93.6615 12.98V13.75C93.3882 13.87 93.1182 13.9567 92.8515 14.01C92.5848 14.07 92.2682 14.1 91.9015 14.1C91.3948 14.1 90.9448 13.9967 90.5515 13.79C90.1648 13.5833 89.8615 13.2767 89.6415 12.87C89.4282 12.4567 89.3215 11.9533 89.3215 11.36C89.3215 10.7733 89.4182 10.27 89.6115 9.85C89.8115 9.43 90.0882 9.10667 90.4415 8.88C90.8015 8.65333 91.2182 8.54 91.6915 8.54ZM91.6815 9.26C91.2615 9.26 90.9282 9.39667 90.6815 9.67C90.4415 9.93667 90.2982 10.31 90.2515 10.79H92.9815C92.9815 10.4833 92.9348 10.2167 92.8415 9.99C92.7482 9.76333 92.6048 9.58667 92.4115 9.46C92.2248 9.32667 91.9815 9.26 91.6815 9.26Z" fill={props.color} />
      <rect x="1.29736" y="0.5" width="101.202" height="19" rx="2.5" stroke={props.color} />
    </svg>
  );
};


export const DirectorCam2 = (props) => {
  return (
    <svg style={{marginBottom:4}} width="16.51" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_11770_1963" fill={"white"}>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.4365 2.66853C11.4365 1.65118 10.6088 0.823529 9.59148 0.823529H6.31074C3.41974 0.823529 1.06767 3.1756 1.06767 6.06669V11.3315C1.06767 12.3488 1.89533 13.1765 2.91267 13.1765H9.59138C10.6087 13.1765 11.4365 12.3488 11.4365 11.3315V5.29029L11.4232 5.27306L11.4365 5.26282V2.66853ZM12.26 4.62781V2.66853C12.26 1.20092 11.0591 0 9.59148 0H6.31074C2.97409 0 0.244141 2.73005 0.244141 6.06669V11.3315C0.244141 12.7992 1.44495 14 2.91267 14H9.59138C11.0591 14 12.26 12.7992 12.26 11.3315V9.51127L14.8189 11.3413L14.8381 11.355L14.8585 11.3668C15.7005 11.8564 16.7563 11.2489 16.7563 10.2749V3.72503C16.7563 2.73253 15.6642 2.12781 14.823 2.65452L14.8023 2.66746L14.783 2.68234L12.26 4.62781ZM12.26 5.89057V8.28186L15.3766 10.5107C15.5492 10.5968 15.7563 10.4718 15.7563 10.2749V3.72503C15.7563 3.52449 15.5422 3.39997 15.3695 3.4929L12.26 5.89057Z"/>
    </mask>
    <path d="M11.4365 5.29029H12.4365V4.94952L12.2284 4.67966L11.4365 5.29029ZM11.4232 5.27306L10.8126 4.48114L10.0207 5.09177L10.6313 5.88369L11.4232 5.27306ZM11.4365 5.26282L12.0471 6.05474L12.4365 5.7545V5.26282H11.4365ZM12.26 4.62781H11.26V6.66165L12.8706 5.41972L12.26 4.62781ZM12.26 9.51127L12.8417 8.69787L11.26 7.56671V9.51127H12.26ZM14.8189 11.3413L14.2372 12.1547L14.2372 12.1547L14.8189 11.3413ZM14.8381 11.355L14.2564 12.1684L14.2947 12.1958L14.3355 12.2195L14.8381 11.355ZM14.8585 11.3668L15.3611 10.5023L15.3611 10.5023L14.8585 11.3668ZM14.823 2.65452L15.3537 3.5021L15.3537 3.50208L14.823 2.65452ZM14.8023 2.66746L14.2717 1.81988L14.2303 1.84576L14.1917 1.87555L14.8023 2.66746ZM14.783 2.68234L15.3937 3.47426L15.3937 3.47425L14.783 2.68234ZM12.26 8.28186H11.26V8.79612L11.6783 9.09526L12.26 8.28186ZM12.26 5.89057L11.6494 5.09866L11.26 5.39889V5.89057H12.26ZM15.3766 10.5107L14.7949 11.3241L14.8593 11.3702L14.9301 11.4055L15.3766 10.5107ZM15.3695 3.4929L14.8957 2.61225L14.8237 2.65102L14.7589 2.70099L15.3695 3.4929ZM9.59148 1.82353C10.0565 1.82353 10.4365 2.20346 10.4365 2.66853H12.4365C12.4365 1.09889 11.1611 -0.176471 9.59148 -0.176471V1.82353ZM6.31074 1.82353H9.59148V-0.176471H6.31074V1.82353ZM2.06767 6.06669C2.06767 3.72787 3.97203 1.82353 6.31074 1.82353V-0.176471C2.86744 -0.176471 0.06767 2.62332 0.06767 6.06669H2.06767ZM2.06767 11.3315V6.06669H0.06767V11.3315H2.06767ZM2.91267 12.1765C2.44761 12.1765 2.06767 11.7965 2.06767 11.3315H0.06767C0.06767 12.9011 1.34304 14.1765 2.91267 14.1765V12.1765ZM9.59138 12.1765H2.91267V14.1765H9.59138V12.1765ZM10.4365 11.3315C10.4365 11.7965 10.0565 12.1765 9.59138 12.1765V14.1765C11.1609 14.1765 12.4365 12.9012 12.4365 11.3315H10.4365ZM10.4365 5.29029V11.3315H12.4365V5.29029H10.4365ZM12.2284 4.67966L12.2151 4.66243L10.6313 5.88369L10.6446 5.90092L12.2284 4.67966ZM12.0338 6.06498L12.0471 6.05474L10.8259 4.4709L10.8126 4.48114L12.0338 6.06498ZM10.4365 2.66853V5.26282H12.4365V2.66853H10.4365ZM13.26 4.62781V2.66853H11.26V4.62781H13.26ZM13.26 2.66853C13.26 0.648637 11.6114 -1 9.59148 -1V1C10.5068 1 11.26 1.7532 11.26 2.66853H13.26ZM9.59148 -1H6.31074V1H9.59148V-1ZM6.31074 -1C2.42179 -1 -0.755859 2.17779 -0.755859 6.06669H1.24414C1.24414 3.28231 3.5264 1 6.31074 1V-1ZM-0.755859 6.06669V11.3315H1.24414V6.06669H-0.755859ZM-0.755859 11.3315C-0.755859 13.3515 0.892669 15 2.91267 15V13C1.99724 13 1.24414 12.2469 1.24414 11.3315H-0.755859ZM2.91267 15H9.59138V13H2.91267V15ZM9.59138 15C11.6113 15 13.26 13.3515 13.26 11.3315H11.26C11.26 12.2469 10.5069 13 9.59138 13V15ZM13.26 11.3315V9.51127H11.26V11.3315H13.26ZM15.4006 10.5279L12.8417 8.69787L11.6783 10.3247L14.2372 12.1547L15.4006 10.5279ZM15.4198 10.5416L15.4006 10.5279L14.2372 12.1547L14.2564 12.1684L15.4198 10.5416ZM15.3611 10.5023L15.3407 10.4905L14.3355 12.2195L14.3558 12.2313L15.3611 10.5023ZM15.7563 10.2749C15.7563 10.4778 15.5365 10.6043 15.3611 10.5023L14.3558 12.2313C15.8645 13.1085 17.7563 12.0201 17.7563 10.2749H15.7563ZM15.7563 3.72503V10.2749H17.7563V3.72503H15.7563ZM15.3537 3.50208C15.5289 3.39239 15.7563 3.51833 15.7563 3.72503H17.7563C17.7563 1.94672 15.7995 0.863224 14.2923 1.80695L15.3537 3.50208ZM15.333 3.51503L15.3537 3.5021L14.2923 1.80694L14.2717 1.81988L15.333 3.51503ZM15.3937 3.47425L15.413 3.45937L14.1917 1.87555L14.1724 1.89043L15.3937 3.47425ZM12.8706 5.41972L15.3937 3.47426L14.1724 1.89043L11.6494 3.83589L12.8706 5.41972ZM13.26 8.28186V5.89057H11.26V8.28186H13.26ZM11.6783 9.09526L14.7949 11.3241L15.9583 9.69731L12.8417 7.46846L11.6783 9.09526ZM14.9301 11.4055C15.761 11.8201 16.7563 11.2221 16.7563 10.2749H14.7563C14.7563 9.72159 15.3373 9.37348 15.8231 9.61593L14.9301 11.4055ZM16.7563 10.2749V3.72503H14.7563V10.2749H16.7563ZM16.7563 3.72503C16.7563 2.76019 15.7278 2.16461 14.8957 2.61225L15.8433 4.37355C15.3567 4.63532 14.7563 4.28879 14.7563 3.72503H16.7563ZM14.7589 2.70099L11.6494 5.09866L12.8706 6.68249L15.9801 4.28482L14.7589 2.70099Z" fill={props.color} mask="url(#path-1-inside-1_11770_1963)"/>
    </svg>
  );
};


export const MuteCam = (props) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.3944 6.68271C14.9209 6.32036 15.6379 6.69735 15.6379 7.33654V12.17H14.6379V7.72898L11.9694 9.56524L11.4025 8.74144L14.3944 6.68271ZM8.76252 9.20715L6.99512 7.63657L7.65938 6.88907L18.5173 16.5378L17.853 17.2853L15.638 15.3169V16.6633C15.638 17.3025 14.921 17.6795 14.3944 17.3172L11.2016 15.1201C10.7896 14.8366 10.3012 14.6848 9.80111 14.6848H8.81187C8.2541 14.6848 7.80194 14.2327 7.80194 13.6749V10.2159C7.80194 9.67467 8.22767 9.23288 8.76252 9.20715ZM14.638 14.4283V16.2709L11.7685 14.2963C11.1897 13.8981 10.5037 13.6848 9.80111 13.6848H8.81187C8.80958 13.6848 8.80865 13.6845 8.80816 13.6843C8.80733 13.6839 8.80611 13.6832 8.80485 13.6819C8.80359 13.6807 8.80286 13.6794 8.80251 13.6786C8.80231 13.6781 8.80194 13.6772 8.80194 13.6749V10.2159C8.80194 10.2136 8.80231 10.2127 8.80251 10.2122C8.80286 10.2114 8.80359 10.2101 8.80485 10.2089C8.80611 10.2076 8.80733 10.2069 8.80816 10.2065C8.80865 10.2063 8.80958 10.206 8.81187 10.206H9.8865L14.638 14.4283Z" fill={props.color} />
      <rect x="1.25586" y="0.5" width="23" height="23" rx="5.5" stroke={props.color} />
    </svg>

  );
};

export const UnMuteCam = (props) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6781 7.30006L10.7143 9.30053C10.2304 9.62714 9.65689 9.80201 9.06951 9.80201H7.94829C7.6732 9.80201 7.4502 10.0208 7.4502 10.2906V13.6048C7.4502 13.8747 7.6732 14.0934 7.94829 14.0934H8.91456C9.50194 14.0934 10.0755 14.2683 10.5594 14.5949L13.6781 16.6999C13.8684 16.8284 14.1275 16.6948 14.1275 16.4681V7.53186C14.1275 7.30525 13.8684 7.1716 13.6781 7.30006Z" stroke={props.color} strokeMiterlimit="10" />
      <path d="M15.7656 10.2798C16.3424 10.8499 17.1498 12.3363 15.7656 13.7205" stroke={props.color} />
      <path d="M16.5312 8.55762C17.6853 9.69853 19.301 12.6728 16.5312 15.4425" stroke={props.color} />
      <rect x="1.25586" y="0.5" width="23" height="23" rx="5.5" stroke={props.color} />
    </svg>
  );
};

export const RealTimeIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73302 0.523926C6.45687 0.523926 6.23302 0.747783 6.23302 1.02393C6.23302 1.30007 6.45687 1.52393 6.73302 1.52393C10.9419 1.52393 14.3538 4.93587 14.3538 9.14471C14.3538 9.42085 14.5777 9.64471 14.8538 9.64471C15.1299 9.64471 15.3538 9.42085 15.3538 9.14471C15.3538 4.38358 11.4941 0.523926 6.73302 0.523926ZM6.73302 2.72151C6.45687 2.72151 6.23302 2.94537 6.23302 3.22151C6.23302 3.49765 6.45687 3.72151 6.73302 3.72151C9.72816 3.72151 12.1562 6.14955 12.1562 9.1447C12.1562 9.42085 12.3801 9.6447 12.6562 9.6447C12.9324 9.6447 13.1562 9.42085 13.1562 9.1447C13.1562 5.59727 10.2804 2.72151 6.73302 2.72151ZM6.13294 5.50128C3.6546 5.50128 1.64551 7.51036 1.64551 9.98871C1.64551 12.4671 3.65461 14.4761 6.13295 14.4761C8.61129 14.4761 10.6204 12.467 10.6204 9.98871C10.6204 9.71257 10.8442 9.48871 11.1204 9.48871C11.3965 9.48871 11.6204 9.71257 11.6204 9.98871C11.6204 13.0193 9.16357 15.4761 6.13295 15.4761C3.10233 15.4761 0.645508 13.0193 0.645508 9.98871C0.645508 6.95808 3.10232 4.50128 6.13294 4.50128C6.40908 4.50128 6.63294 4.72514 6.63294 5.00128C6.63294 5.27742 6.40908 5.50128 6.13294 5.50128ZM6.38766 7.08618C6.38766 6.81004 6.1638 6.58618 5.88766 6.58618C5.61151 6.58618 5.38766 6.81004 5.38766 7.08618V10.3158C5.38766 10.5919 5.61151 10.8158 5.88766 10.8158H7.84993C8.12607 10.8158 8.34993 10.5919 8.34993 10.3158C8.34993 10.0396 8.12607 9.81575 7.84993 9.81575H6.38766V7.08618Z"
        fill={props.color}
      />
    </svg>
  );
};

export const PreDefined = (props) => {
  return (
    <svg
      width="19"
      height="14"
      viewBox="0 0 19 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6875 1H3.3125C2.20793 1 1.3125 1.89543 1.3125 3V11C1.3125 12.1046 2.20793 13 3.3125 13H15.6875C16.7921 13 17.6875 12.1046 17.6875 11V3C17.6875 1.89543 16.7921 1 15.6875 1ZM3.3125 0C1.65565 0 0.3125 1.34315 0.3125 3V11C0.3125 12.6569 1.65565 14 3.3125 14H15.6875C17.3444 14 18.6875 12.6569 18.6875 11V3C18.6875 1.34315 17.3444 0 15.6875 0H3.3125ZM7.8125 3C7.8125 2.72386 8.03636 2.5 8.3125 2.5H10.3125C10.5886 2.5 10.8125 2.72386 10.8125 3C10.8125 3.27614 10.5886 3.5 10.3125 3.5H8.3125C8.03636 3.5 7.8125 3.27614 7.8125 3ZM5.3125 10.5C5.03636 10.5 4.8125 10.7239 4.8125 11C4.8125 11.2761 5.03636 11.5 5.3125 11.5H13.8125C14.0886 11.5 14.3125 11.2761 14.3125 11C14.3125 10.7239 14.0886 10.5 13.8125 10.5H5.3125Z"
        fill={props.color}
        fillOpacity="0.82"
      />
    </svg>
  );
};

export const ArrowDown = (props) => {
  return (
    <svg
      className={props.className}
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.6875 1L4.6875 5L8.6875 1"
        stroke={props.color}
        strokeOpacity="0.82"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CrossIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10.7071L12.6465 13.3536L13.3536 12.6465L10.7071 10L13.3536 7.35359L12.6465 6.64648L10 9.29293L7.35359 6.64648L6.64648 7.35359L9.29293 10L6.64648 12.6465L7.35359 13.3536L10 10.7071Z"
        fill={props.color}
      />
      <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" stroke={props.color} />
    </svg>

  );
};

export const TransitionBuffer = (props) => {

  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill={props.fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 4.5L1.25 7.53109L1.25 1.46891L5 4.5Z"
        stroke={props.color}
        strokeLinejoin="round"
      />
      <path
        d="M7 4.5L10.75 7.53109L10.75 1.46891L7 4.5Z"
        stroke={props.color}
        strokeLinejoin="round"
      />
    </svg>
  );
};




export const PlusIcon = (props) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.58946 1.41064C5.58946 1.1345 5.3656 0.910645 5.08946 0.910645C4.81331 0.910645 4.58946 1.1345 4.58946 1.41064V5.49986H0.5C0.223858 5.49986 0 5.72372 0 5.99986C0 6.276 0.223858 6.49986 0.5 6.49986H4.58946V10.5891C4.58946 10.8653 4.81331 11.0891 5.08946 11.0891C5.3656 11.0891 5.58946 10.8653 5.58946 10.5891V6.49986H9.67847C9.95461 6.49986 10.1785 6.276 10.1785 5.99986C10.1785 5.72372 9.95461 5.49986 9.67847 5.49986H5.58946V1.41064Z"
        fill={props.color}
      />
    </svg>
  );
};

export const DeleteIcon = (props) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.6587 0.91748C3.38255 0.91748 3.1587 1.14134 3.1587 1.41748C3.1587 1.69362 3.38255 1.91748 3.6587 1.91748H6.97363C7.24977 1.91748 7.47363 1.69362 7.47363 1.41748C7.47363 1.14134 7.24977 0.91748 6.97363 0.91748H3.6587ZM0.178711 3.25884C0.178711 2.9827 0.402569 2.75884 0.678711 2.75884H9.9538C10.2299 2.75884 10.4538 2.9827 10.4538 3.25884C10.4538 3.53498 10.2299 3.75884 9.9538 3.75884H9.17126V3.87501V8.08243C9.17126 9.73928 7.82811 11.0824 6.17126 11.0824H4.46145C2.8046 11.0824 1.46145 9.73928 1.46145 8.08243V3.87501V3.75884H0.678711C0.402569 3.75884 0.178711 3.53498 0.178711 3.25884ZM8.17126 3.87501H2.46145V8.08243C2.46145 9.187 3.35688 10.0824 4.46145 10.0824H6.17126C7.27583 10.0824 8.17126 9.187 8.17126 8.08243V3.87501ZM6.42455 5.27359C6.70069 5.27359 6.92455 5.49745 6.92455 5.77359V8.09236C6.92455 8.36851 6.70069 8.59236 6.42455 8.59236C6.14841 8.59236 5.92455 8.36851 5.92455 8.09236V5.77359C5.92455 5.49745 6.14841 5.27359 6.42455 5.27359ZM4.70782 5.77348C4.70782 5.49734 4.48396 5.27348 4.20782 5.27348C3.93168 5.27348 3.70782 5.49734 3.70782 5.77348V8.09226C3.70782 8.3684 3.93168 8.59226 4.20782 8.59226C4.48396 8.59226 4.70782 8.3684 4.70782 8.09226V5.77348Z"
        fill={props.color}
      />
    </svg>
  );
};

export const Timer = (props) => {
  return (
    <svg
      width={props.width ? props.width : "14"}
      height={props.height ? props.height : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="7"
        cy="7"
        r="6.4"
        stroke={props.color}
        strokeWidth="1.2"
        strokeOpacity={props.opacity ? props.opacity : "0.3"}
      />
      <path
        d="M6.85254 3.19312V8.02124L8.74181 6.13196"
        stroke={props.color}
        strokeOpacity={props.opacity ? props.opacity : "0.3"}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PositionsIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.6"
        y="0.6"
        width="18.8"
        height="18.8"
        rx="2.4"
        stroke={props.color}
        strokeWidth="1.2"
      />
      <path d="M7.5 11.5H14.5V14.5H7.5V11.5Z" stroke={props.color} />
      <path d="M7.5 6.5H11.5V8.5H7.5V6.5Z" stroke={props.color} />
      <path
        d="M5 6L5 15"
        stroke={props.color}
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRight = (props) => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L5 5L1 1"
        stroke={props.color}
        strokeOpacity="0.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ImagePlaceholder = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00681 1.5C2.28087 1.5 1.69238 2.08849 1.69238 2.81443V13.7211L5.88604 9.55054L6.2201 9.88646L5.88604 9.55054C6.5569 8.88338 7.64171 8.88674 8.30842 9.55806L9.45849 10.7161L14.0396 6.05771C14.7092 5.37683 15.8064 5.37526 16.4779 6.05421L22.1357 11.7744V2.81443C22.1357 2.08849 21.5472 1.5 20.8213 1.5H3.00681ZM22.1357 13.1965L15.7669 6.75742C15.4876 6.47498 15.0312 6.47564 14.7526 6.75888L10.036 11.555L10.036 11.5551C9.72007 11.8762 9.20264 11.8775 8.88516 11.5579L8.88516 11.5579L7.59889 10.2627L7.95365 9.91039L7.59888 10.2627C7.32154 9.98347 6.87026 9.98207 6.59119 10.2596L1.69238 15.1314V15.1856C1.69238 15.9115 2.28087 16.5 3.00681 16.5H20.8213C21.5472 16.5 22.1357 15.9115 22.1357 15.1856V13.1965ZM0.692383 2.81443C0.692383 1.53621 1.72859 0.5 3.00681 0.5H20.8213C22.0995 0.5 23.1357 1.53621 23.1357 2.81443V15.1856C23.1357 16.4638 22.0995 17.5 20.8213 17.5H3.00681C1.72859 17.5 0.692383 16.4638 0.692383 15.1856V2.81443ZM5.16082 4.02881C4.53751 4.02881 4.03223 4.5341 4.03223 5.1574C4.03223 5.7807 4.53751 6.28599 5.16082 6.28599C5.78412 6.28599 6.28941 5.7807 6.28941 5.1574C6.28941 4.5341 5.78412 4.02881 5.16082 4.02881ZM3.03223 5.1574C3.03223 3.98181 3.98523 3.02881 5.16082 3.02881C6.3364 3.02881 7.28941 3.98181 7.28941 5.1574C7.28941 6.33299 6.3364 7.28599 5.16082 7.28599C3.98523 7.28599 3.03223 6.33299 3.03223 5.1574Z"
        fill={props.color}
      />
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      width="8"
      height="8"
      onClick={(event) => {
        console.log("CloseIcon");
        console.log(event);
        event.stopPropagation();
        event.preventDefault();
        if(props?.deleteLogoHandler) {
          props.deleteLogoHandler();
        }
      }}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.06763 4.70711L7.29241 7.93189L7.99952 7.22478L4.77474 4L7.99952 0.775222L7.29241 0.0681152L4.06763 3.2929L0.842849 0.0681152L0.135742 0.775222L3.36052 4L0.135742 7.22478L0.842849 7.93189L4.06763 4.70711Z"
        fill={props.color}
      />
    </svg>
  );
};

export const DirectorCamPlus = (props) => {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_7583_21747" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1923 2.66853C11.1923 1.65118 10.3647 0.823529 9.34734 0.823529H6.0666C3.1756 0.823529 0.823529 3.1756 0.823529 6.06669V11.3315C0.823529 12.3488 1.65118 13.1765 2.66853 13.1765H9.34724C10.3646 13.1765 11.1923 12.3488 11.1923 11.3315V5.29029L11.1791 5.27306L11.1923 5.26282V2.66853ZM12.0159 4.62781V2.66853C12.0159 1.20092 10.815 0 9.34734 0H6.0666C2.72995 0 0 2.73005 0 6.06669V11.3315C0 12.7992 1.20081 14 2.66853 14H9.34724C10.815 14 12.0159 12.7992 12.0159 11.3315V9.51127L14.5748 11.3413L14.5939 11.355L14.6143 11.3668C15.4563 11.8564 16.5122 11.2489 16.5122 10.2749V3.72503C16.5122 2.73253 15.4201 2.12781 14.5789 2.65452L14.5582 2.66746L14.5389 2.68234L12.0159 4.62781ZM12.0159 5.89057V8.28186L15.1325 10.5107C15.305 10.5968 15.5122 10.4718 15.5122 10.2749V3.72503C15.5122 3.52449 15.2981 3.39997 15.1254 3.4929L12.0159 5.89057ZM6.50778 4.52953C6.50778 4.25338 6.28393 4.02953 6.00778 4.02953C5.73164 4.02953 5.50778 4.25338 5.50778 4.52953V6.50011H3.5372C3.26105 6.50011 3.0372 6.72397 3.0372 7.00011C3.0372 7.27626 3.26105 7.50011 3.5372 7.50011H5.50778V9.4707C5.50778 9.74685 5.73164 9.9707 6.00778 9.9707C6.28393 9.9707 6.50778 9.74685 6.50778 9.4707V7.50011H8.47837C8.75451 7.50011 8.97837 7.27626 8.97837 7.00011C8.97837 6.72397 8.75451 6.50011 8.47837 6.50011H6.50778V4.52953Z"
        />
      </mask>
      <path
        d="M11.1923 5.29029H12.1923V4.94952L11.9843 4.67966L11.1923 5.29029ZM11.1791 5.27306L10.5684 4.48114L9.77651 5.09177L10.3871 5.88369L11.1791 5.27306ZM11.1923 5.26282L11.803 6.05474L12.1923 5.7545V5.26282H11.1923ZM12.0159 4.62781H11.0159V6.66165L12.6265 5.41972L12.0159 4.62781ZM12.0159 9.51127L12.5976 8.69787L11.0159 7.56671V9.51127H12.0159ZM14.5748 11.3413L13.9931 12.1547L13.9931 12.1547L14.5748 11.3413ZM14.5939 11.355L14.0123 12.1684L14.0506 12.1958L14.0913 12.2195L14.5939 11.355ZM14.6143 11.3668L15.1169 10.5023L15.1169 10.5023L14.6143 11.3668ZM14.5789 2.65452L15.1095 3.5021L15.1096 3.50208L14.5789 2.65452ZM14.5582 2.66746L14.0275 1.81988L13.9862 1.84576L13.9476 1.87555L14.5582 2.66746ZM14.5389 2.68234L15.1495 3.47426L15.1495 3.47425L14.5389 2.68234ZM12.0159 8.28186H11.0159V8.79612L11.4342 9.09526L12.0159 8.28186ZM12.0159 5.89057L11.4052 5.09866L11.0159 5.39889V5.89057H12.0159ZM15.1325 10.5107L14.5508 11.3241L14.6151 11.3702L14.686 11.4055L15.1325 10.5107ZM15.1254 3.4929L14.6516 2.61225L14.5795 2.65102L14.5147 2.70099L15.1254 3.4929ZM5.50778 6.50011V7.50011H6.50778V6.50011H5.50778ZM5.50778 7.50011H6.50778V6.50011H5.50778V7.50011ZM6.50778 7.50011V6.50011H5.50778V7.50011H6.50778ZM6.50778 6.50011H5.50778V7.50011H6.50778V6.50011ZM9.34734 1.82353C9.8124 1.82353 10.1923 2.20346 10.1923 2.66853H12.1923C12.1923 1.09889 10.917 -0.176471 9.34734 -0.176471V1.82353ZM6.0666 1.82353H9.34734V-0.176471H6.0666V1.82353ZM1.82353 6.06669C1.82353 3.72787 3.72789 1.82353 6.0666 1.82353V-0.176471C2.6233 -0.176471 -0.176471 2.62332 -0.176471 6.06669H1.82353ZM1.82353 11.3315V6.06669H-0.176471V11.3315H1.82353ZM2.66853 12.1765C2.20347 12.1765 1.82353 11.7965 1.82353 11.3315H-0.176471C-0.176471 12.9011 1.0989 14.1765 2.66853 14.1765V12.1765ZM9.34724 12.1765H2.66853V14.1765H9.34724V12.1765ZM10.1923 11.3315C10.1923 11.7965 9.81237 12.1765 9.34724 12.1765V14.1765C10.9168 14.1765 12.1923 12.9012 12.1923 11.3315H10.1923ZM10.1923 5.29029V11.3315H12.1923V5.29029H10.1923ZM10.3871 5.88369L10.4004 5.90092L11.9843 4.67966L11.971 4.66243L10.3871 5.88369ZM10.5817 4.4709L10.5684 4.48114L11.7897 6.06498L11.803 6.05474L10.5817 4.4709ZM10.1923 2.66853V5.26282H12.1923V2.66853H10.1923ZM13.0159 4.62781V2.66853H11.0159V4.62781H13.0159ZM13.0159 2.66853C13.0159 0.648637 11.3672 -1 9.34734 -1V1C10.2627 1 11.0159 1.7532 11.0159 2.66853H13.0159ZM9.34734 -1H6.0666V1H9.34734V-1ZM6.0666 -1C2.17764 -1 -1 2.17779 -1 6.06669H1C1 3.28231 3.28226 1 6.0666 1V-1ZM-1 6.06669V11.3315H1V6.06669H-1ZM-1 11.3315C-1 13.3515 0.648528 15 2.66853 15V13C1.7531 13 1 12.2469 1 11.3315H-1ZM2.66853 15H9.34724V13H2.66853V15ZM9.34724 15C11.3672 15 13.0159 13.3515 13.0159 11.3315H11.0159C11.0159 12.2469 10.2627 13 9.34724 13V15ZM13.0159 11.3315V9.51127H11.0159V11.3315H13.0159ZM11.4342 10.3247L13.9931 12.1547L15.1565 10.5279L12.5976 8.69787L11.4342 10.3247ZM13.9931 12.1547L14.0123 12.1684L15.1756 10.5416L15.1565 10.5279L13.9931 12.1547ZM14.0913 12.2195L14.1117 12.2313L15.1169 10.5023L15.0966 10.4905L14.0913 12.2195ZM14.1117 12.2313C15.6204 13.1085 17.5122 12.0201 17.5122 10.2749H15.5122C15.5122 10.4778 15.2923 10.6043 15.1169 10.5023L14.1117 12.2313ZM17.5122 10.2749V3.72503H15.5122V10.2749H17.5122ZM17.5122 3.72503C17.5122 1.94672 15.5554 0.863224 14.0482 1.80695L15.1096 3.50208C15.2848 3.39239 15.5122 3.51833 15.5122 3.72503H17.5122ZM14.0482 1.80694L14.0275 1.81988L15.0889 3.51503L15.1095 3.5021L14.0482 1.80694ZM13.9476 1.87555L13.9283 1.89043L15.1495 3.47425L15.1688 3.45937L13.9476 1.87555ZM13.9283 1.89043L11.4052 3.83589L12.6265 5.41972L15.1495 3.47426L13.9283 1.89043ZM13.0159 8.28186V5.89057H11.0159V8.28186H13.0159ZM15.7142 9.69731L12.5976 7.46846L11.4342 9.09526L14.5508 11.3241L15.7142 9.69731ZM14.5122 10.2749C14.5122 9.72159 15.0931 9.37348 15.579 9.61593L14.686 11.4055C15.5169 11.8201 16.5122 11.2221 16.5122 10.2749H14.5122ZM14.5122 3.72503V10.2749H16.5122V3.72503H14.5122ZM15.5991 4.37355C15.1125 4.63532 14.5122 4.28879 14.5122 3.72503H16.5122C16.5122 2.76019 15.4837 2.16461 14.6516 2.61225L15.5991 4.37355ZM12.6265 6.68249L15.736 4.28482L14.5147 2.70099L11.4052 5.09866L12.6265 6.68249ZM6.00778 5.02953C5.73164 5.02953 5.50778 4.80567 5.50778 4.52953H7.50778C7.50778 3.7011 6.83621 3.02953 6.00778 3.02953V5.02953ZM6.50778 4.52953C6.50778 4.80567 6.28393 5.02953 6.00778 5.02953V3.02953C5.17936 3.02953 4.50778 3.7011 4.50778 4.52953H6.50778ZM6.50778 6.50011V4.52953H4.50778V6.50011H6.50778ZM3.5372 7.50011H5.50778V5.50011H3.5372V7.50011ZM4.0372 7.00011C4.0372 7.27626 3.81334 7.50011 3.5372 7.50011V5.50011C2.70877 5.50011 2.0372 6.17169 2.0372 7.00011H4.0372ZM3.5372 6.50011C3.81334 6.50011 4.0372 6.72397 4.0372 7.00011H2.0372C2.0372 7.82854 2.70877 8.50011 3.5372 8.50011V6.50011ZM5.50778 6.50011H3.5372V8.50011H5.50778V6.50011ZM6.50778 9.4707V7.50011H4.50778V9.4707H6.50778ZM6.00778 8.9707C6.28393 8.9707 6.50778 9.19456 6.50778 9.4707H4.50778C4.50778 10.2991 5.17936 10.9707 6.00778 10.9707V8.9707ZM5.50778 9.4707C5.50778 9.19456 5.73164 8.9707 6.00778 8.9707V10.9707C6.83621 10.9707 7.50778 10.2991 7.50778 9.4707H5.50778ZM5.50778 7.50011V9.4707H7.50778V7.50011H5.50778ZM8.47837 6.50011H6.50778V8.50011H8.47837V6.50011ZM7.97837 7.00011C7.97837 6.72397 8.20223 6.50011 8.47837 6.50011V8.50011C9.3068 8.50011 9.97837 7.82854 9.97837 7.00011H7.97837ZM8.47837 7.50011C8.20223 7.50011 7.97837 7.27626 7.97837 7.00011H9.97837C9.97837 6.17169 9.3068 5.50011 8.47837 5.50011V7.50011ZM6.50778 7.50011H8.47837V5.50011H6.50778V7.50011ZM5.50778 4.52953V6.50011H7.50778V4.52953H5.50778Z"
        fill={props.color}
        mask="url(#path-1-inside-1_7583_21747)"
      />
    </svg>
  );
};

//=============================ICONS TO CONTROL DIRECTOR'S IMAGE POSITIONS================================

export const BottomLeft = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="9"
      height="12"
      viewBox="0 0 9 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color: ""}
        d="M1 0.594482C1 0.31834 0.776142 0.0944824 0.5 0.0944824C0.223858 0.0944824 0 0.31834 0 0.594482V7.5401V11.4053V11.4053C0 11.6815 0.223858 11.9053 0.5 11.9053H8.30639C8.58253 11.9053 8.80639 11.6815 8.80639 11.4053V7.5401C8.80639 7.26395 8.58253 7.0401 8.30639 7.0401H1V0.594482ZM1 8.0401V10.9053H7.80639V8.0401H1Z"
        fill={props.color}
      />
    </svg>
  );
};

export const BottomCenter = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        strokeWidth={props.color === "#6C5ECF" ? 3:""}
        d="M5.70984 0.594482C5.70984 0.31834 5.48598 0.0944824 5.20984 0.0944824C4.9337 0.0944824 4.70984 0.31834 4.70984 0.594482V7.04007H1.30664C1.0305 7.04007 0.806641 7.26393 0.806641 7.54007V11.4053C0.806641 11.6814 1.0305 11.9053 1.30664 11.9053H5.20885C5.20918 11.9053 5.20951 11.9053 5.20984 11.9053C5.21017 11.9053 5.2105 11.9053 5.21083 11.9053H9.11304C9.38918 11.9053 9.61304 11.6814 9.61304 11.4053V7.54007C9.61304 7.26393 9.38918 7.04007 9.11304 7.04007H5.70984V0.594482ZM4.70984 8.04007H1.80664V10.9053H4.70984V8.04007ZM5.70984 10.9053V8.04007H8.61304V10.9053H5.70984Z"
        fill={props.color}
      />
    </svg>
  );
};

export const BottomRight = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        d="M9.41968 0.594482C9.41968 0.31834 9.19582 0.0944824 8.91968 0.0944824C8.64354 0.0944824 8.41968 0.31834 8.41968 0.594482V7.04007H1.11328C0.837139 7.04007 0.613281 7.26393 0.613281 7.54007V11.4053C0.613281 11.6814 0.837139 11.9053 1.11328 11.9053H8.91869C8.91902 11.9053 8.91935 11.9053 8.91968 11.9053C9.19582 11.9053 9.41968 11.6814 9.41968 11.4053V7.54007V0.594482ZM8.41968 10.9053V8.04007H1.61328V10.9053H8.41968Z"
        fill={props.color}
      />
    </svg>
  );
};

export const MiddleLeft = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        d="M1.29004 0.594482C1.29004 0.31834 1.06618 0.0944824 0.790039 0.0944824C0.513897 0.0944824 0.290039 0.31834 0.290039 0.594482V4.06728V7.9325V11.4053C0.290039 11.6814 0.513897 11.9053 0.790039 11.9053C1.06618 11.9053 1.29004 11.6814 1.29004 11.4053V8.4325H8.59644C8.87258 8.4325 9.09644 8.20865 9.09644 7.9325V4.06728C9.09644 3.79114 8.87258 3.56728 8.59644 3.56728H1.29004V0.594482ZM1.29004 4.56728V7.4325H8.09644V4.56728H1.29004Z"
        fill={props.color}
      />
    </svg>
  );
};

export const MiddleCenter = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        strokeWidth={props.color === "#6C5ECF" ? 2.7 : ""}
        d="M4.99988 0.594482C4.99988 0.31834 4.77602 0.0944824 4.49988 0.0944824C4.22374 0.0944824 3.99988 0.31834 3.99988 0.594482V3.56728H0.596679C0.320537 3.56728 0.0966797 3.79114 0.0966797 4.06728V7.9325C0.0966797 8.20865 0.320537 8.4325 0.596679 8.4325H3.99988V11.4053C3.99988 11.6814 4.22374 11.9053 4.49988 11.9053C4.77602 11.9053 4.99988 11.6814 4.99988 11.4053V8.4325H8.40308C8.67922 8.4325 8.90308 8.20865 8.90308 7.9325V4.06728C8.90308 3.79114 8.67922 3.56728 8.40308 3.56728H4.99988V0.594482ZM3.99988 4.56728H1.09668V7.4325H3.99988V4.56728ZM4.99988 7.4325V4.56728H7.90308V7.4325H4.99988Z"
        fill={props.color}
      />
    </svg>
  );
};

export const MiddleRight = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        d="M9.70972 0.594482C9.70972 0.31834 9.48586 0.0944824 9.20972 0.0944824C8.93358 0.0944824 8.70972 0.31834 8.70972 0.594482V3.56728H1.40332C1.12718 3.56728 0.90332 3.79114 0.90332 4.06728V7.9325C0.90332 8.20865 1.12718 8.4325 1.40332 8.4325H8.70972V11.4053C8.70972 11.6814 8.93358 11.9053 9.20972 11.9053C9.48586 11.9053 9.70972 11.6814 9.70972 11.4053V7.9325V4.06728V0.594482ZM8.70972 7.4325V4.56728H1.90332V7.4325H8.70972Z"
        fill={props.color}
      />
    </svg>
  );
};

export const TopLeft = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        d="M1.58105 11.4053V4.9597H8.88745C9.1636 4.9597 9.38745 4.73585 9.38745 4.4597V0.594482C9.38745 0.31834 9.1636 0.0944824 8.88745 0.0944824H1.08105C0.989983 0.0944824 0.904598 0.118831 0.831055 0.161374C0.737353 0.215577 0.662874 0.299316 0.620347 0.39986C0.595046 0.459679 0.581055 0.525447 0.581055 0.594482V4.4597V11.4053C0.581055 11.6814 0.804912 11.9053 1.08105 11.9053C1.3572 11.9053 1.58105 11.6814 1.58105 11.4053ZM1.58105 3.9597H8.38745V1.09448H1.58105V3.9597Z"
        fill={props.color}
      />
    </svg>


  );
};

export const TopCenter = (props) => {
  return (
    <svg
      onClick={props.onClick}
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        clipRule={props.color !== "#6C5ECF" ? "evenodd" : undefined}
        stroke={props.color === "#6C5ECF" ? props.color : ""}
        d="M8.6941 4.9597C8.97024 4.9597 9.1941 4.73585 9.1941 4.4597V0.594482C9.1941 0.31834 8.97024 0.0944824 8.6941 0.0944824H4.79089H0.887695C0.611552 0.0944824 0.387695 0.31834 0.387695 0.594482V4.4597C0.387695 4.73585 0.611552 4.9597 0.887695 4.9597H4.29089V11.4053C4.29089 11.6814 4.51475 11.9053 4.79089 11.9053C5.06704 11.9053 5.29089 11.6814 5.29089 11.4053V4.9597H8.6941ZM5.29089 3.9597H8.1941V1.09448H5.29089V3.9597ZM4.29089 1.09448H1.38769V3.9597H4.29089V1.09448Z"
        fill={props.color}
      />
    </svg>
  );
};

export const TopRight = (props) => {
  return (
    props.color !== "#6C5ECF" ?
     <svg
      width="9"
      height="12"
      viewBox="0 0 9 12"
      fill="none"
      onClick={props.onClick}
    >
      <path
        d="m7.8064,1v2.86522H1V1h6.8064ZM.5,4.86522h7.3064v6.44559c0,.27614.22386.5.5.5s.5-.22386.5-.5V.5c0-.27614-.22386-.5-.5-.5H.5C.22386,0,0,.22386,0,.5v3.86522c0,.27614.22386.5.5.5Z"
        fill={props.color}
      />
    </svg>
      :
    <svg
      onClick={props.onClick}
      width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path

        d="M7.99976 4.95983H0.693359C0.417216 4.95983 0.193359 4.73597 0.193359 4.45983V0.594604C0.193359 0.318462 0.417216 0.0946045 0.693359 0.0946045H8.49976C8.7759 0.0946045 8.99976 0.318462 8.99976 0.594604V4.45983V11.4054C8.99976 11.6816 8.7759 11.9054 8.49976 11.9054C8.22362 11.9054 7.99976 11.6816 7.99976 11.4054V4.95983Z" fill={props.color} />
    </svg>

  );
};

export const RemoveCam = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9766 8.51363C9.78134 8.31837 9.46476 8.31837 9.26949 8.51363C9.07423 8.7089 9.07423 9.02548 9.26949 9.22074L12.0486 11.9998L9.26956 14.7789C9.0743 14.9741 9.0743 15.2907 9.26956 15.486C9.46483 15.6813 9.78141 15.6813 9.97667 15.486L12.7557 12.707L15.5347 15.486C15.73 15.6813 16.0466 15.6813 16.2418 15.486C16.4371 15.2907 16.4371 14.9741 16.2418 14.7789L13.4628 11.9998L16.2419 9.22074C16.4372 9.02548 16.4372 8.7089 16.2419 8.51363C16.0467 8.31837 15.7301 8.31837 15.5348 8.51363L12.7557 11.2927L9.9766 8.51363Z"
        fill={props.color}
      />
      <rect
        x="1.25586"
        y="0.5"
        width="23"
        height="23"
        rx="5.5"
        stroke={props.color}
      />
    </svg>
  );
};

export const NoneIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.5 1L1 15.5" stroke={props.color} strokeLinejoin="round" />
    </svg>
  );
};

export const CloseIconRounded = (props) => {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16" height="16" rx="8" fill="#171717" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99984 8.70713L10.3765 11.0838L11.0836 10.3767L8.70694 8.00003L11.0837 5.62331L10.3766 4.91621L7.99984 7.29292L5.62312 4.91621L4.91602 5.62331L7.29273 8.00003L4.91607 10.3767L5.62318 11.0838L7.99984 8.70713Z"
        fill="white"
      />
    </svg>
  );
};

export const AddTemplate = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.50074 0.78595C8.50074 0.509807 8.27688 0.28595 8.00074 0.28595C7.7246 0.28595 7.50074 0.509807 7.50074 0.78595V7.49997H0.786133C0.509991 7.49997 0.286133 7.72383 0.286133 7.99997C0.286133 8.27612 0.509991 8.49997 0.786133 8.49997H7.50074V15.214C7.50074 15.4901 7.7246 15.714 8.00074 15.714C8.27688 15.714 8.50074 15.4901 8.50074 15.214V8.49997H15.2142C15.4903 8.49997 15.7142 8.27612 15.7142 7.99997C15.7142 7.72383 15.4903 7.49997 15.2142 7.49997H8.50074V0.78595Z"
        fill={props.color}
      />
    </svg>
  );
};

export const DirectorIcon = (props) => {
  return (
    <svg
      className={props.className}
      style={{ position: "relative", top: 6 }}
      width={props.width? props.width : "25"}
      height={props.height ? props.height: "28"}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.13315 7.15942V0.990906H5.13315V1.53139H12.9141V0.990906H13.9141V7.15942H17.2098V8.15942H15.9792V10.9858C15.9792 11.8018 15.3178 12.4632 14.5018 12.4632H13.584L9.47867 15.2581L13.7114 18.1396L13.1486 18.9662L8.59018 15.8629L4.03175 18.9662L3.469 18.1396L7.70169 15.2581L3.59637 12.4632H3.41915C2.60319 12.4632 1.94174 11.8018 1.94174 10.9858V8.15942H0.790283V7.15942H4.13315ZM8.59018 14.6532L11.807 12.4632H5.37335L8.59018 14.6532ZM2.94174 8.15942V10.9858C2.94174 11.2495 3.15548 11.4632 3.41915 11.4632H4.13315V8.15942H2.94174ZM5.13315 11.4632H12.9141V7.24507H5.13315V11.4632ZM13.9141 11.4632H14.5018C14.7655 11.4632 14.9792 11.2495 14.9792 10.9858V8.15942H13.9141V11.4632ZM12.9141 2.53139V6.24507H5.13315V2.53139H12.9141Z"
        fill={props.color}
      />
    </svg>
  );
};
export const DirectorIconSmall = (props) => {
  return (
      <svg
          className={props.className}
          style={{ position: "relative", top: 6, marginRight: 10 }}
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="18"
          viewBox="0 0 17 18"
          fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.63291 6.18085V0.0123291H4.63291V0.552814H12.4138V0.0123291H13.4138V6.18085H16.7095V7.18085H15.479V10.0072C15.479 10.8232 14.8175 11.4847 14.0016 11.4847H13.0837L8.97843 14.2795L13.2111 17.161L12.6484 17.9876L8.08993 14.8843L3.53151 17.9876L2.96875 17.161L7.20144 14.2795L3.09612 11.4847H2.9189C2.10295 11.4847 1.44149 10.8232 1.44149 10.0072V7.18085H0.290039V6.18085H3.63291ZM8.08993 13.6746L11.3068 11.4847H4.8731L8.08993 13.6746ZM2.44149 7.18085V10.0072C2.44149 10.2709 2.65523 10.4847 2.9189 10.4847H3.63291V7.18085H2.44149ZM4.63291 10.4847H12.4138V6.26649H4.63291V10.4847ZM13.4138 10.4847H14.0016C14.2652 10.4847 14.479 10.2709 14.479 10.0072V7.18085H13.4138V10.4847ZM12.4138 1.55281V5.26649H4.63291V1.55281H12.4138Z"
            fill="#171717"/>
      </svg>
  );
};


export const InfoIcon = (props) => {
  return (
    <svg width={props.width ? props.width : "15"} height={props.height ? props.height : "16"} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="9.5" r="8.25" stroke={props.color} strokeOpacity="0.82" stroke-width="1.5"/>
    <path d="M9 5.70251V10.2025" stroke={props.color} strokeOpacity="0.82" stroke-width="1.5"/>
    <circle cx="9" cy="12.1456" r="1" fill={props.color} fillOpacity="0.82"/>
    </svg>
  );
};

export const BulletIcon = (props) => {
  return (
      <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 4.13397C7.16667 4.51887 7.16667 5.48113 6.5 5.86603L2 8.4641C1.33333 8.849 0.5 8.36788 0.5 7.59808L0.5 2.40192C0.5 1.63212 1.33333 1.151 2 1.5359L6.5 4.13397Z" stroke={props.color}/>
      </svg>


  );
};

export const OptionIcon = (props) => {
  return (
      <svg  className={props.className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="3" fill={props.color} />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.5 6C6.5 6.55228 6.05228 7 5.5 7C4.94772 7 4.5 6.55228 4.5 6C4.5 5.44772 4.94772 5 5.5 5C6.05228 5 6.5 5.44772 6.5 6ZM5.5 4C6.43192 4 7.21497 4.63739 7.43699 5.5H12.5V6.5H7.43699C7.21497 7.36261 6.43192 8 5.5 8C4.39543 8 3.5 7.10457 3.5 6C3.5 4.89543 4.39543 4 5.5 4ZM9.5 10C9.5 10.5523 9.94772 11 10.5 11C11.0523 11 11.5 10.5523 11.5 10C11.5 9.44772 11.0523 9 10.5 9C9.94772 9 9.5 9.44772 9.5 10ZM8.56301 10.5C8.78503 11.3626 9.56808 12 10.5 12C11.6046 12 12.5 11.1046 12.5 10C12.5 8.89543 11.6046 8 10.5 8C9.56808 8 8.78503 8.63739 8.56301 9.5H3.5V10.5H8.56301Z" fill={props.stroke} />
      </svg>


  );
};


export const ChangeTemplateIcon = (props) => {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 4.33333H8.75L5.72531 1" stroke={props.color} strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.75 7.66667H1.25L4.27469 11" stroke={props.color} strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

  )
}


export const EmojiIcon = () => {
  return (
    <svg
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 42.70193 31.79575"
    >
    <path class="cls-2" d="m11.35545,13.03562h18.71188s1.01061-.10419,1.01061.90642-1.26066,5.51146-3.99034,7.38682-6.37621,2.36503-8.87668,1.5628-4.43834-1.9587-4.98011-2.65675-1.82326-3.11517-2.1775-4.4696-.59386-2.58382.30214-2.72968Z" />
    <path class="cls-2" d="m17.66828,8.82382c-.05106,1.30556-.98986,1.88905-1.8918,1.88905s-1.71126-.87648-1.71126-1.87864,1.06892-1.81457,1.97086-1.81457,1.68272.51211,1.63219,1.80415Z" />
    <path class="cls-2" d="m28.19538,8.93648c-.04801,1.2277-.93082,1.77639-1.77898,1.77639s-1.6092-.82421-1.6092-1.7666,1.00517-1.70635,1.85332-1.70635,1.58237.48157,1.53486,1.69656Z" />
    <path fill="#eadcff" d="m14.46145,13.78227h12.12156s.51928.04451.29673.53412-1.70622,1.55785-2.84864,1.69138-5.39231.47446-6.13414.47446-2.41178-1.03825-3.00524-1.78009-.57863-.84569-.43026-.91987Z" />
    <path fill="#eadcff" d="m17.83457,21.18377s2.00697-1.71002,3.38933-1.6793,2.21177.0512,3.08214,1.52571c0,0,.26623.56318-.34815.70654s-1.86767.29695-2.85889.32767-3.20299-.27647-3.3361-.36863-.13303-.34621.07168-.51198Z" />
    <path class="cls-2" d="m36.18339,9.51979c-.7271-2.40349-2.78722-4.62519-4.58479-5.37249s-2.46407-1.43402-3.89809-2.2217c-1.43402-.7877-3.15079-1.45422-5.02914-1.77737-1.87835-.32317-5.23113-.0202-6.05921,0s-3.51434.90888-5.02914,1.64437-3.17099,2.90004-4.10006,3.9099c-.92908,1.00987-2.3631,3.37297-2.66605,4.20106-.30297.8281-1.41382,5.55428-1.41382,5.55428-.20197,1.99954-.34335,4.66559,1.79757,8.11933,2.14092,3.45376,6.60453,6.1602,9.53315,7.08928s8.60408,1.33302,10.36125,1.03007c1.75717-.30297,3.47394-1.13105,5.81683-2.03994,2.3429-.90888,5.79664-4.46361,6.11981-7.99815.32315-3.53454-.12118-9.73513-.8483-12.13862Zm-.8829,5.67508c-.13969,5.14515-.95453,8.8003-3.79484,10.68608-2.8403,1.88579-6.18613,2.91016-11.28804,2.46782-5.10193-.44234-6.56865-.48891-10.27037-2.65406s-5.02874-4.89714-5.09858-7.54716c0,0,.04656-4.62892,.34921-5.86284,.30266-1.2339,2.18844-5.4478,3.49218-6.54202,1.30376-1.09422,2.24331-2.91803,5.95251-3.9501s5.68811-1.54426,9.34326-.4966,5.07531,2.70061,5.89016,3.16624,.81485,.46562,3.14297,1.81594,1.65297,1.69952,2.42123,3.77155,2.28156,8.9167Z" />
    <path class="cls-2" d="m38.54307,11.9687s.38917-.33856,.97832-.70002,1.94149-1.6472,2.52372-1.36058,.98286,.74991,.29241,1.47914-2.95272,1.26085-3.34205,1.14597c0,0,-.58106-.08186,-.4524-.56452Z" />
    <path class="cls-2" d="m38.25278,9.13828s.22876-.46233,.63326-1.0228,1.15736-2.26786,1.80506-2.22757,.46751,.31354,.83951,1.25243-2.23937,2.30076-2.64292,2.34469c0,0,-.56777,.14823,-.63491,-.34675Z" />
    <path class="cls-2" d="m3.62236,8.68168s-.22876-.46233-.63326-1.0228-1.15736-2.26786-1.80506-2.22757S-.01181,5.74485,.34453,6.68374s2.23937,2.30076,2.64292,2.34469c0,0,.56777,.14823,.63491,-.34675Z" />
    <path class="cls-2" d="m38.58188,22.50863s-.47569,2.37843-1.47991,3.27695" />
    <path class="cls-2" d="m40.6132,21.54331s-.85828,4.69712-2.52021,5.85189" />
    <path class="cls-2" d="m1.9427,20.42326s-.67497-2.63427-.26399-5.01775" />
    <path class="cls-2" d="m.17027,19.50406s-.3155-1.58967-.08755-2.90898" />
  </svg>

  )
}
export const YoutubeIcon = (props) => {
  return (
    <svg width="81" height="18" viewBox="0 0 81 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1772 2.81071C24.8814 1.70425 24.0102 0.833069 22.9038 0.537321C20.8983 -1.98995e-06 12.8572 0 12.8572 0C12.8572 0 4.81606 -1.98995e-06 2.81055 0.537321C1.70425 0.833069 0.832913 1.70425 0.537165 2.81071C0 4.81606 0 9.00016 0 9.00016C0 9.00016 0 13.1841 0.537165 15.1893C0.832913 16.2957 1.70425 17.1671 2.81055 17.4628C4.81606 18 12.8572 18 12.8572 18C12.8572 18 20.8983 18 22.9038 17.4628C24.0102 17.1671 24.8814 16.2957 25.1772 15.1893C25.7146 13.1841 25.7146 9.00016 25.7146 9.00016C25.7146 9.00016 25.7146 4.81606 25.1772 2.81071ZM10.2867 12.8578L16.9674 9.00068L10.2867 5.14336V12.8578ZM40.3875 12.8083C40.3875 13.642 40.3168 14.2428 40.176 14.6102C40.035 14.9781 39.7867 15.1619 39.4314 15.1619C39.0755 15.1619 38.8305 14.9781 38.6958 14.6102C38.5607 14.2428 38.4935 13.642 38.4935 12.8083V9.29588C38.4935 8.4869 38.564 7.8954 38.705 7.52139C38.8458 7.14769 39.0881 6.9606 39.4314 6.9606C39.7867 6.9606 40.035 7.14769 40.176 7.52139C40.3168 7.8954 40.3875 8.4869 40.3875 9.29588V12.8083ZM36.2409 14.7757C36.455 15.4993 36.8168 16.0329 37.3259 16.3757C37.8343 16.7189 38.5361 16.8905 39.4314 16.8905C40.3018 16.8905 40.9911 16.722 41.5001 16.3849C42.0086 16.0478 42.3765 15.5148 42.6034 14.7852C42.8302 14.0559 42.9436 13.0902 42.9436 11.8888V10.2523C42.9436 9.03856 42.827 8.06721 42.5944 7.33745C42.3613 6.60832 41.9935 6.07178 41.491 5.72863C40.9883 5.38533 40.3202 5.21367 39.4865 5.21367C38.6406 5.21367 37.9571 5.38233 37.4361 5.71934C36.9149 6.05651 36.5319 6.59288 36.2869 7.32847C36.0415 8.06375 35.9191 9.03856 35.9191 10.2523V11.8888C35.9191 13.0902 36.0262 14.0527 36.2409 14.7757ZM76.7064 7.17175C76.5779 7.33128 76.4917 7.59175 76.449 7.95317C76.4059 8.3149 76.3849 8.86356 76.3849 9.59916V10.4084H78.2418V9.59916C78.2418 8.87585 78.2172 8.32718 78.1684 7.95317C78.1193 7.57947 78.0306 7.31616 77.902 7.16262C77.773 7.00939 77.5738 6.9327 77.3042 6.9327C77.0342 6.9327 76.8352 7.01254 76.7064 7.17175ZM76.3849 11.9163V12.4864C76.3849 13.2099 76.4059 13.7521 76.449 14.1136C76.4917 14.4754 76.5805 14.7392 76.7157 14.9047C76.8506 15.07 77.0586 15.153 77.341 15.153C77.7207 15.153 77.9815 15.0056 78.1224 14.7114C78.2632 14.4173 78.3399 13.927 78.3522 13.2403L80.5405 13.3691C80.5528 13.4675 80.559 13.602 80.559 13.7735C80.559 14.8157 80.2741 15.5943 79.7038 16.1091C79.1341 16.6239 78.3276 16.8815 77.2857 16.8815C76.0353 16.8815 75.1586 16.4892 74.6561 15.7043C74.1533 14.9201 73.902 13.7064 73.902 12.0634V10.0955C73.902 8.40388 74.1626 7.16892 74.6837 6.39034C75.2046 5.61175 76.0966 5.22246 77.3594 5.22246C78.2295 5.22246 78.8979 5.38183 79.3637 5.70057C79.8294 6.01963 80.1574 6.516 80.3475 7.19018C80.5375 7.86451 80.6327 8.79632 80.6327 9.9853V11.9163H76.3849ZM28.2586 1.27793L31.1457 11.7045V16.7066H33.6466V11.7045L36.5704 1.27793H34.051L33.0028 6.02218C32.7087 7.40785 32.5186 8.39447 32.4329 8.98281H32.3592C32.2367 8.16171 32.0468 7.1688 31.7891 6.00376L30.7778 1.27793H28.2586ZM51.1357 5.4334V16.7058H49.1497L48.9289 15.3269H48.8738C48.3343 16.369 47.5251 16.8898 46.4464 16.8898C45.6987 16.8898 45.147 16.6447 44.7914 16.1543C44.4358 15.6641 44.2582 14.8977 44.2582 13.8558V5.4334H46.7958V13.7085C46.7958 14.2114 46.8511 14.5699 46.9614 14.7841C47.0718 14.9989 47.2557 15.1062 47.513 15.1062C47.7338 15.1062 47.9453 15.0388 48.1473 14.9038C48.3497 14.7688 48.4998 14.5975 48.598 14.389V5.4334H51.1357ZM64.154 16.7058V5.4334H61.6164V14.389C61.5181 14.5975 61.3681 14.7688 61.1657 14.9038C60.9636 15.0388 60.7522 15.1062 60.5314 15.1062C60.274 15.1062 60.0901 14.9989 59.9796 14.7841C59.8693 14.5699 59.8142 14.2114 59.8142 13.7085V5.4334H57.2766V13.8558C57.2766 14.8977 57.454 15.6641 57.8098 16.1543C58.1654 16.6447 58.7169 16.8898 59.4647 16.8898C60.5435 16.8898 61.3525 16.369 61.8925 15.3269H61.9473L62.1681 16.7058H64.154ZM58.0301 3.31919H55.5107V16.7064H53.0282V3.31919H50.509V1.27793H58.0301V3.31919ZM70.1234 13.7637C70.1906 13.298 70.2246 12.6544 70.2246 11.8328V10.38C70.2246 9.49735 70.1969 8.81704 70.1418 8.33908C70.0865 7.86066 69.9883 7.5205 69.8475 7.31814C69.7064 7.11609 69.5073 7.01483 69.2498 7.01483C69.0045 7.01483 68.778 7.11326 68.5695 7.309C68.361 7.50522 68.2139 7.75672 68.1281 8.06302V14.4624C68.2386 14.6586 68.3823 14.8057 68.5604 14.9038C68.7379 15.0019 68.9309 15.0509 69.1397 15.0509C69.4089 15.0509 69.6238 14.9529 69.7832 14.7567C69.9426 14.5608 70.056 14.2298 70.1234 13.7637ZM71.8059 5.68995C72.149 6.00901 72.3972 6.52397 72.5508 7.23483C72.7038 7.94601 72.7805 8.93294 72.7805 10.1956V11.9791C72.7805 13.6589 72.5783 14.8939 72.1738 15.6846C71.769 16.4751 71.1377 16.8707 70.2797 16.8707C69.8016 16.8707 69.3662 16.7603 68.9739 16.5397C68.5815 16.3189 68.2873 16.0186 68.0912 15.6386H68.0363L67.7786 16.7051H65.6824V0.706641H68.1281L68.1279 6.64633H68.1465C68.3671 6.21735 68.6799 5.87105 69.0845 5.60743C69.4889 5.34397 69.9242 5.212 70.39 5.212C70.9905 5.212 71.4626 5.37137 71.8059 5.68995Z"
        fill="#C8C1C1"
        fillOpacity="0.8" />
    </svg>
  );
};

export const Youtube = (props) => {
  return (
    <svg width="46" height="10" viewBox="0 0 46 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5713 1.5615C14.407 0.946806 13.923 0.462816 13.3083 0.298512C12.1941 -1.10553e-06 7.72685 0 7.72685 0C7.72685 0 3.25958 -1.10553e-06 2.1454 0.298512C1.53079 0.462816 1.04671 0.946806 0.88241 1.5615C0.583984 2.67559 0.583984 5.00009 0.583984 5.00009C0.583984 5.00009 0.583984 7.3245 0.88241 8.4385C1.04671 9.05319 1.53079 9.53727 2.1454 9.70158C3.25958 10 7.72685 10 7.72685 10C7.72685 10 12.1941 10 13.3083 9.70158C13.923 9.53727 14.407 9.05319 14.5713 8.4385C14.8699 7.3245 14.8699 5.00009 14.8699 5.00009C14.8699 5.00009 14.8699 2.67559 14.5713 1.5615Z" fill="#ED1F24" />
      <path d="M6.29883 7.14276L10.0103 4.99989L6.29883 2.85693V7.14276Z" fill="white" />
      <path d="M22.904 8.11678C22.9822 7.91267 23.0215 7.5789 23.0215 7.11573V5.16438C23.0215 4.71495 22.9822 4.38634 22.904 4.17855C22.8257 3.97094 22.6877 3.867 22.4903 3.867C22.2996 3.867 22.165 3.97094 22.0867 4.17855C22.0084 4.38634 21.9692 4.71495 21.9692 5.16438V7.11573C21.9692 7.5789 22.0066 7.91267 22.0817 8.11678C22.1565 8.32116 22.2926 8.42326 22.4903 8.42326C22.6877 8.42326 22.8257 8.32116 22.904 8.11678ZM21.3206 9.09762C21.0378 8.90716 20.8368 8.61075 20.7178 8.20873C20.5986 7.80707 20.5391 7.27234 20.5391 6.60488V5.6957C20.5391 5.02142 20.607 4.47986 20.7434 4.07138C20.8795 3.66271 21.0923 3.36473 21.3818 3.17741C21.6713 2.99019 22.051 2.89648 22.521 2.89648C22.9841 2.89648 23.3552 2.99185 23.6345 3.18257C23.9137 3.37321 24.1181 3.67129 24.2476 4.07636C24.3768 4.48179 24.4415 5.02142 24.4415 5.6957V6.60488C24.4415 7.27234 24.3785 7.80882 24.2525 8.21398C24.1265 8.61932 23.9221 8.91547 23.6396 9.1027C23.3568 9.29001 22.9739 9.38362 22.4903 9.38362C21.993 9.38362 21.603 9.28826 21.3206 9.09762Z" fill={props.color} />
      <path d="M43.1986 3.98382C43.1272 4.07244 43.0794 4.21715 43.0557 4.41794C43.0317 4.6189 43.0201 4.92371 43.0201 5.33238V5.78198H44.0516V5.33238C44.0516 4.93054 44.038 4.62573 44.0109 4.41794C43.9836 4.21033 43.9343 4.06405 43.8628 3.97874C43.7912 3.89362 43.6805 3.85101 43.5307 3.85101C43.3808 3.85101 43.2702 3.89537 43.1986 3.98382ZM43.0201 6.61969V6.9364C43.0201 7.33832 43.0317 7.63955 43.0557 7.84042C43.0794 8.04139 43.1287 8.18793 43.2038 8.27988C43.2788 8.37175 43.3943 8.41785 43.5512 8.41785C43.7621 8.41785 43.907 8.33596 43.9853 8.17253C44.0635 8.0091 44.1062 7.73675 44.113 7.35521L45.3287 7.42678C45.3356 7.48146 45.339 7.55617 45.339 7.65145C45.339 8.23045 45.1807 8.663 44.8639 8.949C44.5474 9.235 44.0993 9.37813 43.5205 9.37813C42.8258 9.37813 42.3388 9.1602 42.0596 8.72415C41.7803 8.28845 41.6406 7.61418 41.6406 6.7014V5.60814C41.6406 4.66833 41.7854 3.98224 42.0749 3.5497C42.3643 3.11715 42.8599 2.90088 43.5614 2.90088C44.0448 2.90088 44.4161 2.98942 44.6749 3.1665C44.9336 3.34375 45.1159 3.61951 45.2215 3.99405C45.3271 4.36868 45.3799 4.88636 45.3799 5.5469V6.61969H43.0201Z" fill={props.color} />
      <path d="M17.8871 6.50252L16.2832 0.709961H17.6828L18.2446 3.33542C18.3878 3.98266 18.4933 4.53428 18.5613 4.99045H18.6023C18.6499 4.66359 18.7555 4.11547 18.9189 3.34566L19.5012 0.709961H20.9009L19.2766 6.50252V9.28144H17.8871V6.50252Z" fill={props.color} />
      <path d="M28.9927 3.01904V9.28151H27.8894L27.7667 8.51546H27.7361C27.4364 9.09437 26.9868 9.3837 26.3875 9.3837C25.9721 9.3837 25.6657 9.24757 25.4681 8.97513C25.2706 8.70277 25.1719 8.27696 25.1719 7.69813V3.01904H26.5817V7.61633C26.5817 7.89568 26.6124 8.0949 26.6736 8.21388C26.735 8.33322 26.8371 8.3928 26.9801 8.3928C27.1028 8.3928 27.2203 8.35535 27.3325 8.28037C27.4449 8.2054 27.5283 8.11021 27.5829 7.99437V3.01904H28.9927Z" fill={props.color} />
      <path d="M36.2251 3.01904V9.28151H35.1218L34.9991 8.51546H34.9687C34.6687 9.09437 34.2193 9.3837 33.62 9.3837C33.2045 9.3837 32.8981 9.24757 32.7005 8.97513C32.5029 8.70277 32.4043 8.27696 32.4043 7.69813V3.01904H33.8141V7.61633C33.8141 7.89568 33.8447 8.0949 33.906 8.21388C33.9674 8.33322 34.0696 8.3928 34.2125 8.3928C34.3352 8.3928 34.4527 8.35535 34.5649 8.28037C34.6773 8.2054 34.7607 8.11021 34.8153 7.99437V3.01904H36.2251Z" fill={props.color} />
      <path d="M32.8229 1.84399H31.4233V9.28135H30.0441V1.84399H28.6445V0.709961H32.8229V1.84399Z" fill={props.color} />
      <path d="M39.5977 6.57426C39.5977 7.03069 39.5788 7.38826 39.5414 7.64696C39.504 7.90593 39.441 8.08983 39.3524 8.19867C39.2639 8.30768 39.1445 8.3621 38.995 8.3621C38.8789 8.3621 38.7717 8.33489 38.6731 8.28038C38.5741 8.22588 38.4943 8.14416 38.4329 8.03515V4.47994C38.4806 4.30978 38.5623 4.17006 38.6782 4.06105C38.794 3.9523 38.9198 3.89762 39.0561 3.89762C39.1992 3.89762 39.3097 3.95387 39.3881 4.06612C39.4663 4.17854 39.5209 4.36752 39.5516 4.63331C39.5823 4.89884 39.5977 5.27679 39.5977 5.76717V6.57426ZM40.89 4.01984C40.8047 3.62491 40.6668 3.33882 40.4761 3.16157C40.2854 2.98458 40.0231 2.89604 39.6895 2.89604C39.4307 2.89604 39.1889 2.96936 38.9642 3.11573C38.7395 3.26218 38.5657 3.45457 38.4432 3.69289H38.4328L38.4329 0.393066H37.0742V9.28108H38.2388L38.3819 8.6886H38.4125C38.5214 8.89972 38.6848 9.06656 38.9028 9.18922C39.1208 9.31179 39.3627 9.37312 39.6283 9.37312C40.1049 9.37312 40.4557 9.15335 40.6805 8.71415C40.9053 8.27487 41.0176 7.58878 41.0176 6.65554V5.66472C41.0176 4.96323 40.975 4.41494 40.89 4.01984Z" fill={props.color} />
    </svg>


  )
}


export const QuickGuideIcon = (props) => {
  return (
  <svg  width="24" height="24" viewBox="0 0 24 24" fill="none">
    <mask id={props.theme === 'dark' ? "mask0_129_6833" : "mask0_102_5805"} style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" fill={props.theme === 'dark' ? "#EADCFF" : "#3B3B3B"}/>
    </mask>
    <g mask={props.theme === 'dark' ? "url(#mask0_129_6833)" : "url(#mask0_102_5805)"}>
        <path
          d="M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM11.05 14.15H12.9C12.9 13.6 12.9625 13.1667 13.0875 12.85C13.2125 12.5333 13.5667 12.1 14.15 11.55C14.5833 11.1167 14.925 10.7042 15.175 10.3125C15.425 9.92083 15.55 9.45 15.55 8.9C15.55 7.96667 15.2083 7.25 14.525 6.75C13.8417 6.25 13.0333 6 12.1 6C11.15 6 10.3792 6.25 9.7875 6.75C9.19583 7.25 8.78333 7.85 8.55 8.55L10.2 9.2C10.2833 8.9 10.4708 8.575 10.7625 8.225C11.0542 7.875 11.5 7.7 12.1 7.7C12.6333 7.7 13.0333 7.84583 13.3 8.1375C13.5667 8.42917 13.7 8.75 13.7 9.1C13.7 9.43333 13.6 9.74583 13.4 10.0375C13.2 10.3292 12.95 10.6 12.65 10.85C11.9167 11.5 11.4667 11.9917 11.3 12.325C11.1333 12.6583 11.05 13.2667 11.05 14.15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={props.theme === 'dark' ? "#EADCFF" : "#3B3B3B"}
        />
    </g>
  </svg>
  )
}


export const BulletIconSec = (props) => {
  return (
  <svg className={props.className} width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.266406 0.199951L9.7998 6.99995L0.266406 13.4889V0.199951Z" fill="#8B7EE6"/>
  </svg>
  )
}


export const ReplayIcon = (props) => {
  return (
    
  <svg className={props.className} onClick={props.onClick} width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g mask="url(#mask0_191_8585)">
      <path d="M16 29.3333C14.3333 29.3333 12.7722 29.0166 11.3167 28.3833C9.86111 27.75 8.59444 26.8944 7.51667 25.8166C6.43889 24.7389 5.58333 23.4722 4.95 22.0166C4.31667 20.5611 4 19 4 17.3333H6.66667C6.66667 19.9333 7.57222 22.1389 9.38333 23.95C11.1944 25.7611 13.4 26.6666 16 26.6666C18.6 26.6666 20.8056 25.7611 22.6167 23.95C24.4278 22.1389 25.3333 19.9333 25.3333 17.3333C25.3333 14.7333 24.4278 12.5278 22.6167 10.7166C20.8056 8.90554 18.6 7.99998 16 7.99998H15.8L17.8667 10.0666L16 12L10.6667 6.66665L16 1.33331L17.8667 3.26665L15.8 5.33331H16C17.6667 5.33331 19.2278 5.64998 20.6833 6.28331C22.1389 6.91665 23.4056 7.7722 24.4833 8.84998C25.5611 9.92776 26.4167 11.1944 27.05 12.65C27.6833 14.1055 28 15.6666 28 17.3333C28 19 27.6833 20.5611 27.05 22.0166C26.4167 23.4722 25.5611 24.7389 24.4833 25.8166C23.4056 26.8944 22.1389 27.75 20.6833 28.3833C19.2278 29.0166 17.6667 29.3333 16 29.3333Z" fill="white"/>
    </g>
  </svg>

  )
}


export const StarIcon = (props) => {
  return (
    <svg width={props.size} height={props.size} viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 0L19.0514 10.5837L30 14.5L19.0514 18.4163L15 29L10.9486 18.4163L0 14.5L10.9486 10.5837L15 0Z" fill="white"/>
    </svg>
  )
}


export const RightIcon = () => {
  return (  
  <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.6 6.5L0 1.9L1.4 0.5L7.4 6.5L1.4 12.5L0 11.1L4.6 6.5Z" fill="white"/>
  </svg>
  )
}


export const QuestionMark = (props) => {
  return (
    
    <svg style={{cursor:'pointer'}} onClick={props.onClick} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill={props.color}/>
      </mask>
      <g>
        <path
          d="M11.95 18C12.3 18 12.5958 17.8792 12.8375 17.6375C13.0792 17.3958 13.2 17.1 13.2 16.75C13.2 16.4 13.0792 16.1042 12.8375 15.8625C12.5958 15.6208 12.3 15.5 11.95 15.5C11.6 15.5 11.3042 15.6208 11.0625 15.8625C10.8208 16.1042 10.7 16.4 10.7 16.75C10.7 17.1 10.8208 17.3958 11.0625 17.6375C11.3042 17.8792 11.6 18 11.95 18ZM11.05 14.15H12.9C12.9 13.6 12.9625 13.1667 13.0875 12.85C13.2125 12.5333 13.5667 12.1 14.15 11.55C14.5833 11.1167 14.925 10.7042 15.175 10.3125C15.425 9.92083 15.55 9.45 15.55 8.9C15.55 7.96667 15.2083 7.25 14.525 6.75C13.8417 6.25 13.0333 6 12.1 6C11.15 6 10.3792 6.25 9.7875 6.75C9.19583 7.25 8.78333 7.85 8.55 8.55L10.2 9.2C10.2833 8.9 10.4708 8.575 10.7625 8.225C11.0542 7.875 11.5 7.7 12.1 7.7C12.6333 7.7 13.0333 7.84583 13.3 8.1375C13.5667 8.42917 13.7 8.75 13.7 9.1C13.7 9.43333 13.6 9.74583 13.4 10.0375C13.2 10.3292 12.95 10.6 12.65 10.85C11.9167 11.5 11.4667 11.9917 11.3 12.325C11.1333 12.6583 11.05 13.2667 11.05 14.15ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill={props.color}
        />
      </g>
    </svg>

  )
}

export const DirectIconSec = () => {
  return (  
  <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.63315 6.18097V0.0124512H4.63315V0.552937H12.4141V0.0124512H13.4141V6.18097H16.7098V7.18097H15.4792V10.0074C15.4792 10.8233 14.8178 11.4848 14.0018 11.4848H13.084L8.97867 14.2796L13.2114 17.1611L12.6486 17.9878L8.09018 14.8845L3.53175 17.9878L2.969 17.1611L7.20169 14.2796L3.09637 11.4848H2.91915C2.10319 11.4848 1.44174 10.8233 1.44174 10.0074V7.18097H0.290283V6.18097H3.63315ZM8.09018 13.6747L11.307 11.4848H4.87335L8.09018 13.6747ZM2.44174 7.18097V10.0074C2.44174 10.271 2.65548 10.4848 2.91915 10.4848H3.63315V7.18097H2.44174ZM4.63315 10.4848H12.4141V6.26661H4.63315V10.4848ZM13.4141 10.4848H14.0018C14.2655 10.4848 14.4792 10.271 14.4792 10.0074V7.18097H13.4141V10.4848ZM12.4141 1.55294V5.26661H4.63315V1.55294H12.4141Z"
        fill="#171717"
      />
  </svg>
  )
}


export const ArrowForward = () => {
  return(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <g mask="url(#mask0_1019_7276)">
        <path
          d="M10.6999 29.3333L8.33325 26.9667L19.2999 16L8.33325 5.03333L10.6999 2.66667L24.0333 16L10.6999 29.3333Z"
          fill="white"
        />
    </g>
  </svg>
  )
}